// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sections Styles - Dark Premium */

.section-container {
  max-width: 1400px;
  margin: 0 auto;
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.spin-smooth {
  animation: spin 3s linear infinite;
}

@keyframes pulse-glow {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);
  }

  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(16, 185, 129, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}

@keyframes float-subtle {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-5px);
  }
}

@keyframes icon-pop {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2) rotate(5deg);
  }

  100% {
    transform: scale(1.1) rotate(0deg);
  }
}

.section-header {
  margin-bottom: 2.5rem;
  padding-bottom: 1rem;
  border-bottom: var(--glass-border);
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.header-title-stack {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.section-header h2 {
  font-size: 2.8rem;
  font-weight: 850;
  margin: 0;
  letter-spacing: -0.04em;
  line-height: 1;
  background: var(--gradient-heading);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.header-subtitle {
  margin: 0;
  font-size: 0.95rem;
  color: var(--text-secondary);
  font-weight: 500;
  opacity: 0.8;
}

html[data-theme="light"] .section-header {
  border-bottom-color: rgba(0, 0, 0, 0.05);
}

html[data-theme="light"] .section-header h2 {
  background: linear-gradient(to right, #0f172a, #64748b);
  -webkit-background-clip: text;
  background-clip: text;
}

html[data-theme="light"] .btn-secondary {
  background: white;
  border-color: rgba(0, 0, 0, 0.1);
  color: #1e293b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

html[data-theme="light"] .btn-secondary:hover {
  background: #f8fafc;
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.chart-bar {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0.8;
}

.chart-bar:hover {
  opacity: 1;
  filter: brightness(1.2) drop-shadow(0 0 5px rgba(16, 185, 129, 0.5));
}

@keyframes barGrow {
  from {
    height: 0;
    transform: translateY(100%);
  }

  to {
    height: var(--final-height);
    transform: translateY(0);
  }
}

.charts-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.chart-wrapper {
  position: relative;
  min-height: 240px;
  /* Reduced from 280px */
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  /* Reduced from 1.5rem */
  padding: 0.5rem;
  /* Reduced from 1rem */
}

/* Connect Button (generic) */
.btn-primary {
  padding: 0.75rem 1.75rem;
  background: var(--gradient-main);
  color: white;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  position: relative;
  overflow: hidden;
}

.btn-primary::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(255, 255, 255, 0.1), transparent);
  opacity: 0;
  transition: opacity 0.3s;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.6);
}

.btn-primary:hover::after {
  opacity: 1;
}

.btn-primary:active {
  transform: translateY(0) scale(0.97);
}

/* Migration Jobs (Beautified Collapsible Design) */
.jobs-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0.5rem;
}

.migration-box {
  background: var(--card-bg);
  backdrop-filter: blur(14px);
  border: 1px solid var(--card-border);
  border-radius: 16px;
  position: relative;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

/* Premium "Internal Border" */
.migration-box::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 8px;
  right: 8px;
  bottom: 8px;
  border: 1px solid rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  pointer-events: none;
  z-index: 1;
}

/* Premium "L-Shaped" Depth */
.migration-box::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: -10px;
  bottom: -10px;
  border-right: 1.5px solid var(--card-border);
  border-bottom: 1.5px solid var(--card-border);
  border-radius: 20px;
  z-index: -1;
  opacity: 0.4;
  transition: all 0.4s ease;
  pointer-events: none;
}

.migration-box:hover {
  transform: translateY(-4px);
  border-color: rgba(99, 102, 241, 0.4);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
}

.migration-box:hover::after {
  transform: translate(4px, 4px);
  opacity: 0.6;
}

.migration-box.expanded {
  border-color: var(--primary);
  background: rgba(99, 102, 241, 0.05);
}

.migration-header-compact {
  padding: 1.25rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.migration-header-compact .main-info {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.migration-header-compact .name-group {
  display: flex;
  align-items: baseline;
  gap: 1rem;
}

.migration-header-compact .name-group h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-main);
  letter-spacing: -0.02em;
}

.migration-header-compact .job-id-tag {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(255, 255, 255, 0.05);
  padding: 0.2rem 0.6rem;
  border-radius: 6px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.7rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.migration-header-compact .job-id-tag .label {
  color: var(--text-muted);
  font-weight: 700;
}

.migration-header-compact .job-id-tag .value {
  color: var(--primary);
  font-weight: 700;
}

.migration-header-compact .date-group {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.85rem;
  color: var(--text-secondary);
  opacity: 0.8;
}

.compact-speed {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(244, 114, 182, 0.1);
  /* Pink-ish background */
  color: #f472b6;
  padding: 0.2rem 0.6rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  border: 1px solid rgba(244, 114, 182, 0.2);
}

.compact-speed .speed-icon {
  filter: drop-shadow(0 0 3px currentColor);
}

.migration-header-compact .status-group {
  display: flex;
  align-items: center;
  gap: 1rem;
  /* Reduced for better grouping */
}

.status-badge {
  padding: 0.4rem 0.9rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  min-width: 120px;
  /* Uniform width for badges */
  justify-content: center;
}

.expand-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.03);
  color: var(--text-muted);
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.migration-box:hover .expand-icon {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.1);
  color: var(--primary);
}

.migration-box.expanded .expand-icon {
  color: var(--primary);
  transform: rotate(180deg);
}

.header-actions {
  display: flex;
  gap: 0.75rem;
  margin-right: 0.5rem;
}

.action-icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.action-icon-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.1);
}

.action-icon-btn.delete:hover:not(:disabled) {
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.4);
  background: rgba(239, 68, 68, 0.1);
  box-shadow: 0 0 15px rgba(239, 68, 68, 0.2);
}

.action-icon-btn.cancel:hover:not(:disabled) {
  color: #fbbf24;
  border-color: rgba(251, 191, 36, 0.4);
  background: rgba(251, 191, 36, 0.1);
  box-shadow: 0 0 15px rgba(251, 191, 36, 0.2);
}

.action-icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-cancel {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.8rem;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  color: #fbbf24;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel:hover:not(:disabled) {
  background: rgba(245, 158, 11, 0.2);
  border-color: rgba(245, 158, 11, 0.5);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
}

.btn-cancel:active {
  transform: translateY(0);
}

.btn-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Light Mode Overrides */
html[data-theme="light"] .btn-cancel {
  background: rgba(245, 158, 11, 0.1);
  border-color: rgba(245, 158, 11, 0.3);
  color: #b45309;
}

html[data-theme="light"] .btn-cancel:hover:not(:disabled) {
  background: rgba(245, 158, 11, 0.15);
  border-color: rgba(245, 158, 11, 0.4);
}

.migration-dropdown-content {
  padding: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0 0 16px 16px;
  animation: slidePanel 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

@keyframes slidePanel {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.detail-item .label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: var(--text-muted);
  font-weight: 700;
}

.detail-item .value {
  font-size: 1rem;
  color: var(--text-main);
  font-weight: 600;
}

.detail-item .value.highlight {
  color: #818cf8;
  /* Indigo 400 */
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.detail-item .speed-value {
  color: #f472b6;
  /* Pink 400 */
}

.progress-stack {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.mini-progress-bar {
  height: 10px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 5px;
  overflow: hidden;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3);
  margin-top: 0.5rem;
}

.mini-progress-bar .progress-fill {
  height: 100%;
  border-radius: 5px;
  transition: width 1s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s ease;
  box-shadow: 0 0 10px currentColor;
}

/* Status Colors (Unified for Progress) */
.status-color-pending {
  color: #fbbf24 !important;
  /* Amber 400 (Yellow) */
  border-color: rgba(251, 191, 36, 0.3);
  background: rgba(251, 191, 36, 0.08);
}

.status-color-running {
  color: #fbbf24 !important;
  /* Amber 400 (Yellow) */
  border-color: rgba(251, 191, 36, 0.3);
  background: rgba(251, 191, 36, 0.1);
  box-shadow: 0 0 15px rgba(251, 191, 36, 0.1);
}

.status-color-completed {
  color: #10b981 !important;
  /* Emerald 500 (Green) */
  border-color: rgba(16, 185, 129, 0.3);
  background: rgba(16, 185, 129, 0.08);
  box-shadow: 0 0 15px rgba(16, 185, 129, 0.1);
}

.status-color-failed {
  color: #ef4444 !important;
  /* Red 500 */
  border-color: rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.08);
  box-shadow: 0 0 15px rgba(239, 68, 68, 0.1);
}

.mini-progress-bar .progress-fill.status-color-pending,
.mini-progress-bar .progress-fill.status-color-running {
  background-color: #fbbf24 !important;
  box-shadow: 0 0 12px rgba(251, 191, 36, 0.4);
}

.mini-progress-bar .progress-fill.status-color-completed {
  background-color: #10b981 !important;
  box-shadow: 0 0 12px rgba(16, 185, 129, 0.4);
}

.mini-progress-bar .progress-fill.status-color-failed {
  background-color: #ef4444 !important;
  box-shadow: 0 0 12px rgba(239, 68, 68, 0.4);
}

/* Light Theme Overrides */
html[data-theme="light"] .migration-box {
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

html[data-theme="light"] .migration-dropdown-content {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

html[data-theme="light"] .status-badge {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

html[data-theme="light"] .mini-progress-bar {
  background: #e2e8f0;
}

/* Cards (Generic) */
.section-card-base {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.section-card-base:hover {
  background: var(--card-hover-bg);
  border-color: rgba(99, 102, 241, 0.4);
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -10px var(--card-shadow);
}

/* Connections Grid */
.connections-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.connection-card {
  background: var(--card-bg);
  backdrop-filter: blur(10px);
  border: 1px solid var(--card-border);
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.connection-card:hover {
  background: var(--card-hover-bg);
  border-color: rgba(99, 102, 241, 0.4);
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -10px var(--card-shadow);
}

.connection-card.test-success {
  background: rgba(16, 185, 129, 0.15) !important;
  border-color: #10b981 !important;
  backdrop-filter: blur(16px);
  box-shadow: 0 8px 32px 0 rgba(16, 185, 129, 0.2);
}

.connection-card.test-success .connection-info h3,
.connection-card.test-success .detail-value,
.connection-card.test-success .detail-label,
.connection-card.test-success .connection-type,
.connection-card.test-success .connection-icon {
  color: #10b981 !important;
}

.connection-card.test-success .connection-icon {
  background: rgba(16, 185, 129, 0.2) !important;
}

.connection-card.test-failed {
  background: rgba(239, 68, 68, 0.15) !important;
  border-color: #ef4444 !important;
  backdrop-filter: blur(16px);
  box-shadow: 0 8px 32px 0 rgba(239, 68, 68, 0.2);
}

.connection-card.test-failed .connection-info h3,
.connection-card.test-failed .detail-value,
.connection-card.test-failed .detail-label,
.connection-card.test-failed .connection-type,
.connection-card.test-failed .connection-icon {
  color: #ef4444 !important;
}

.connection-card.test-failed .connection-icon {
  background: rgba(239, 68, 68, 0.2) !important;
}

html[data-theme="light"] .connection-card.test-success {
  background: #d1fae5 !important;
  /* Emerald 100 */
  border-color: #10b981 !important;
}

html[data-theme="light"] .connection-card.test-success .connection-info h3,
html[data-theme="light"] .connection-card.test-success .detail-value,
html[data-theme="light"] .connection-card.test-success .detail-label,
html[data-theme="light"] .connection-card.test-success .connection-type,
html[data-theme="light"] .connection-card.test-success .connection-icon {
  color: #065f46 !important;
  /* Emerald 800 */
}

html[data-theme="light"] .connection-card.test-failed {
  background: #fee2e2 !important;
  /* Red 100 */
  border-color: #ef4444 !important;
}

html[data-theme="light"] .connection-card.test-failed .connection-info h3,
html[data-theme="light"] .connection-card.test-failed .detail-value,
html[data-theme="light"] .connection-card.test-failed .detail-label,
html[data-theme="light"] .connection-card.test-failed .connection-type,
html[data-theme="light"] .connection-card.test-failed .connection-icon {
  color: #991b1b !important;
  /* Red 800 */
}

.connection-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.connection-icon {
  width: 50px;
  height: 50px;
  flex: 0 0 50px;
  min-width: 50px;
  min-height: 50px;
  border-radius: 50%;
  padding: 0;
  background: rgba(99, 102, 241, 0.1);
  color: #a5b4fc;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.connection-icon svg,
.connection-icon img {
  display: block;
  transition: transform 0.3s ease;
  max-width: 100%;
  max-height: 100%;
}

.connection-card:hover .connection-icon svg,
.connection-card:hover .connection-icon img {
  transform: scale(1.1);
}

.connection-info h3 {
  margin: 0;
  color: var(--text-main);
  font-size: 1.1rem;
}

.connection-type {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.provider-badge-small {
  display: inline-block;
  margin-top: 0.5rem;
  padding: 0.15rem 0.6rem;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: 1px solid transparent;
}

/* AWS Logo Fix for Dark Mode */
.aws-logo-img {
  filter: invert(1) hue-rotate(180deg);
  transition: all 0.3s ease;
  transform: scale(1.4);
  /* Zoom in */
}

html[data-theme="light"] .aws-logo-img {
  filter: none;
}

.connection-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  padding: 0.5rem 0;
  border-bottom: var(--glass-border);
}

.detail-label {
  color: var(--text-muted);
}

.detail-value {
  color: var(--text-main);
  font-family: 'JetBrains Mono', monospace;
  font-weight: 600;
  word-break: break-all;
}

/* Overhauled Connection Card Styles */
.card-top-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
}

.role-label {
  font-size: 0.65rem;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 6px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.role-label.role-source {
  background: rgba(99, 102, 241, 0.1);
  color: #818cf8;
  border: 1px solid rgba(99, 102, 241, 0.2);
}

.role-label.role-destination {
  background: rgba(168, 85, 247, 0.1);
  color: #a855f7;
  border: 1px solid rgba(168, 85, 247, 0.2);
}

.connection-name {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-main);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: -0.01em;
}

.connection-subtitle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.region-pill {
  font-size: 0.6rem;
  padding: 1px 6px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  color: var(--text-muted);
  font-family: 'JetBrains Mono', monospace;
  text-transform: uppercase;
}

.connection-actions {
  display: flex;
  gap: 6px;
}

.btn-test-icon,
.btn-edit-icon,
.btn-delete-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--card-border);
  background: rgba(255, 255, 255, 0.03);
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-test-icon:hover {
  color: #10b981;
  border-color: rgba(16, 185, 129, 0.4);
  background: rgba(16, 185, 129, 0.1);
  transform: translateY(-2px);
}

.btn-edit-icon:hover {
  color: var(--primary-color);
  border-color: rgba(168, 85, 247, 0.4);
  background: rgba(168, 85, 247, 0.1);
  transform: translateY(-2px);
}

.btn-delete-icon:hover {
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.4);
  background: rgba(239, 68, 68, 0.1);
  transform: translateY(-2px);
}

.connection-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
  margin: 1.5rem 0;
  padding: 1.25rem;
  background: rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.03);
  border-radius: 14px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-item.full-width {
  grid-column: span 2;
}

.detail-item label {
  font-size: 0.6rem;
  text-transform: uppercase;
  color: var(--text-muted);
  font-weight: 800;
  letter-spacing: 0.08em;
  opacity: 0.6;
}

.detail-item .value,
.detail-item .value-wrap {
  font-size: 0.85rem;
  color: var(--text-main);
  font-family: 'JetBrains Mono', monospace;
  font-weight: 600;
}

.detail-item .value-wrap {
  word-break: break-all;
  line-height: 1.5;
  opacity: 0.9;
}

.card-footer-provider {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.provider-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.small-logo {
  opacity: 0.8;
}

.created-at {
  font-size: 0.65rem;
  color: var(--text-muted);
  opacity: 0.5;
}

.btn-test {
  flex: 1 1;
  padding: 0.6rem;
  background: var(--surface-light);
  border: var(--glass-border);
  color: var(--text-main);
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-test:hover {
  background: #10b981;
  border-color: #059669;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

html[data-theme="light"] .btn-test {
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.08);
  color: var(--text-main);
}

html[data-theme="light"] .btn-test:hover {
  background: #10b981;
  color: white;
  border-color: #059669;
}

html[data-theme="light"] .btn-delete-small {
  color: #dc2626;
  background: rgba(220, 38, 38, 0.1);
  border-color: rgba(220, 38, 38, 0.2);
}

html[data-theme="light"] .btn-delete-small:hover {
  background: rgba(220, 38, 38, 0.2);
  border-color: rgba(220, 38, 38, 0.4);
}

.btn-edit-small {
  padding: 0.6rem;
  background: rgba(99, 102, 241, 0.1);
  color: #a5b4fc;
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-edit-small:hover {
  background: rgba(99, 102, 241, 0.2);
  border-color: rgba(99, 102, 241, 0.4);
}

html[data-theme="light"] .btn-edit-small {
  color: #4f46e5;
  background: rgba(79, 70, 229, 0.1);
  border-color: rgba(79, 70, 229, 0.2);
}

html[data-theme="light"] .btn-edit-small:hover {
  background: rgba(79, 70, 229, 0.2);
  border-color: rgba(79, 70, 229, 0.4);
}

html[data-theme="light"] .btn-edit-small {
  color: #4f46e5;
  background: rgba(79, 70, 229, 0.1);
  border-color: rgba(79, 70, 229, 0.2);
}

html[data-theme="light"] .btn-edit-small:hover {
  background: rgba(79, 70, 229, 0.2);
  border-color: rgba(79, 70, 229, 0.4);
}

.btn-delete-small {
  padding: 0.6rem;
  background: rgba(239, 68, 68, 0.1);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-delete-small:hover {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.4);
}

/* Jobs Grid */
.jobs-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

.job-card {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 2rem;
  align-items: center;
}

.job-card:hover {
  background: var(--card-hover-bg);
  border-color: rgba(99, 102, 241, 0.4);
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -10px var(--card-shadow);
}

.job-info h3 {
  margin: 0;
  color: var(--text-main);
  font-size: 1.1rem;
}

.job-meta {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.migration-path {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.connection-box {
  background: var(--surface-light);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: var(--glass-border);
  text-align: center;
  min-width: 140px;
}

.connection-label {
  display: block;
  font-size: 0.7rem;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 0.25rem;
}

.connection-name {
  color: var(--text-main);
  font-weight: 600;
  /* Bolder name */
}

.migration-arrow {
  color: #6366f1;
  font-size: 1.25rem;
}

/* Monitor Section Enhancements */
.monitor-details-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 2rem;
  margin-top: 2rem;
  align-items: stretch;
  /* Cards will be same height */
}

.header-icon {
  color: var(--primary);
  filter: drop-shadow(0 0 8px rgba(99, 102, 241, 0.4));
}

.title-group {
  display: flex;
  flex-direction: column;
}

.title-group h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-main);
}

.subtitle {
  font-size: 0.75rem;
  color: var(--text-muted);
  font-weight: 400;
}

.graph-description {
  font-size: 0.8rem;
  color: #94a3b8;
  margin-top: 2px;
  max-width: 320px;
}

.graph-legend.compact {
  margin-top: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.02);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.75rem;
  color: var(--text-muted);
  font-weight: 500;
  letter-spacing: 0.02em;
}

.legend-color {
  width: 10px;
  height: 3px;
  border-radius: 2px;
}

.legend-color.speed {
  background: var(--primary);
  box-shadow: 0 0 10px rgba(99, 102, 241, 0.4);
}

.legend-color.events {
  background: #10b981;
  box-shadow: 0 0 10px rgba(16, 185, 129, 0.4);
}

.live-indicator.miniature {
  margin-left: auto;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #10b981;
  background: rgba(16, 185, 129, 0.05);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  border: 1px solid rgba(16, 185, 129, 0.1);
}

html[data-theme="light"] .graph-description {
  color: #64748b;
}

html[data-theme="light"] .graph-legend.compact {
  background: rgba(0, 0, 0, 0.02);
  border-color: rgba(0, 0, 0, 0.05);
}

html[data-theme="light"] .legend-item {
  color: #64748b;
}

html[data-theme="light"] .graph-legend {
  background: rgba(0, 0, 0, 0.02);
}

.monitor-card {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  height: 520px;
  /* Fixed "perfect" small height */
}

.monitor-card:hover {
  border-color: rgba(99, 102, 241, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
}

.monitor-card-header {
  padding: 1.5rem 2rem;
  background: rgba(255, 255, 255, 0.02);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.header-title {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: var(--text-main);
}

.header-title h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.job-selector {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.2);
  color: var(--text-main);
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-size: 0.85rem;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
}

.job-selector:hover {
  border-color: var(--primary);
  background: rgba(0, 0, 0, 0.4);
}

.log-viewer {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 1.5rem;
  background: rgba(2, 6, 23, 0.6);
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  font-size: 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  scrollbar-width: thin;
  scrollbar-color: rgba(99, 102, 241, 0.3) transparent;
}

.log-viewer::-webkit-scrollbar {
  width: 6px;
}

.log-viewer::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.3);
  border-radius: 10px;
}

.log-entry {
  background: transparent !important;
  border: none !important;
  border-bottom: 1px solid var(--glass-border, rgba(255, 255, 255, 0.05)) !important;
  padding: 0.65rem 0.75rem !important;
  margin-bottom: 0 !important;
  transition: background 0.2s ease !important;
  width: 100% !important;
  box-sizing: border-box !important;
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: fit-content !important;
  border-radius: 0 !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.log-entry:hover {
  background: rgba(99, 102, 241, 0.04) !important;
}

/* Status indicator on the left */
.log-entry::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  opacity: 0.6;
}

.level-info.log-entry::before {
  background: #3b82f6;
}

.level-warn.log-entry::before {
  background: #f59e0b;
}

.level-error.log-entry::before {
  background: #ef4444;
}

.level-success.log-entry::before {
  background: #10b981;
}

.log-line {
  display: flex !important;
  align-items: center !important;
  gap: 1rem !important;
  width: 100% !important;
}

.log-time {
  color: var(--text-muted, #94a3b8) !important;
  font-size: 0.7rem !important;
  white-space: nowrap !important;
  font-family: 'Outfit', sans-serif !important;
  min-width: 80px !important;
  opacity: 0.7 !important;
  background: transparent !important;
  text-align: left !important;
}

.log-badge {
  padding: 0.15rem 0.45rem !important;
  border-radius: 4px !important;
  font-size: 0.65rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  min-width: 55px !important;
  text-align: center !important;
}

.badge-info {
  background: rgba(59, 130, 246, 0.1) !important;
  color: #60a5fa !important;
}

.badge-warn {
  background: rgba(245, 158, 11, 0.1) !important;
  color: #fbbf24 !important;
}

.badge-error {
  background: rgba(239, 68, 68, 0.1) !important;
  color: #f87171 !important;
}

.badge-success {
  background: rgba(16, 185, 129, 0.1) !important;
  color: #34d399 !important;
}

.log-msg {
  flex: 1 1 !important;
  color: var(--text-main, #e2e8f0) !important;
  line-height: 1.5 !important;
  font-weight: 400 !important;
  word-break: break-word !important;
  font-size: 0.85rem !important;
}

.empty-logs {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  gap: 1rem;
  opacity: 0.5;
}

.chart-canvas-wrapper {
  position: relative;
  width: 100%;
}

.chart-point {
  opacity: 0;
  cursor: help;
  transition: opacity 0.2s, r 0.2s;
}

.chart-point:hover {
  opacity: 1;
  r: 6;
}

.chart-bar {
  transition: fill 0.3s, opacity 0.3s;
  cursor: help;
}

.chart-bar:hover {
  opacity: 0.8;
  fill: #34d399;
  /* Menthe */
}

.throughput-svg {
  width: 100%;
  height: auto;
  overflow: visible;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  color: var(--text-muted);
  margin-bottom: 1rem;
  /* Reduced from 2rem */
}

.header-left-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.live-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.65rem;
  font-weight: 800;
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
  padding: 0.25rem 0.6rem;
  border-radius: 20px;
  letter-spacing: 0.05em;
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.pulse-dot {
  width: 6px;
  height: 6px;
  background: #10b981;
  border-radius: 50%;
  animation: pulse 1.5s infinite;
  box-shadow: 0 0 8px #10b981;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    opacity: 0.7;
  }

  50% {
    transform: scale(1.2);
    opacity: 1;
    box-shadow: 0 0 12px #10b981;
  }

  100% {
    transform: scale(0.95);
    opacity: 0.7;
  }
}

.chart-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--text-muted);
  margin-bottom: 1rem;
  /* Reduced from 2rem */
}

.chart-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-main);
}

.throughput-svg {
  width: 100%;
  height: auto;
  overflow: visible;
  filter: drop-shadow(0 0 10px rgba(99, 102, 241, 0.2));
}

.mini-stats-row.premium {
  display: flex;
  align-items: stretch;
  gap: 1.25rem;
  padding: 1rem 1.5rem;
  background: rgba(2, 6, 23, 0.4);
  border-top: 1px solid rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
}

.mini-stat.premium {
  background: rgba(15, 23, 42, 0.5);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow:
    0 10px 30px -10px rgba(0, 0, 0, 0.5),
    inset 0 1px 1px rgba(255, 255, 255, 0.05);
  padding: 1.75rem;
  transition: all 0.5s cubic-bezier(0.22, 1, 0.36, 1);
  overflow: hidden;
  position: relative;
}

.stat-glow-bg {
  position: absolute;
  top: -20%;
  right: -20%;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, var(--accent-color, rgba(99, 102, 241, 0.1)) 0%, transparent 70%);
  filter: blur(40px);
  pointer-events: none;
  z-index: 0;
  opacity: 0.5;
  transition: opacity 0.5s ease;
}

.mini-stat.performance-card {
  --accent-color: rgba(245, 158, 11, 0.15);
}

.mini-stat.speed-card {
  --accent-color: rgba(99, 102, 241, 0.15);
}

.mini-label-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  z-index: 1;
}

.mini-label {
  font-size: 0.7rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-weight: 800;
  opacity: 0.7;
}

.stat-main-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1;
  z-index: 1;
}

.mini-val-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.mini-val {
  font-size: 2.25rem;
  font-weight: 800;
  background: var(--gradient-heading);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;
}

.mini-val.highlight {
  background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%);
  -webkit-background-clip: text;
  background-clip: text;
}

.mini-val.success {
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
  -webkit-background-clip: text;
  background-clip: text;
}

.mini-val.failed {
  background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
  -webkit-background-clip: text;
  background-clip: text;
}

.primary-speed {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
}

.unit {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-muted);
  opacity: 0.6;
}

.mini-stat.premium:hover {
  background: rgba(30, 41, 59, 0.6);
  border-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-8px) scale(1.02);
  box-shadow:
    0 20px 40px -15px rgba(0, 0, 0, 0.6),
    inset 0 1px 1px rgba(255, 255, 255, 0.1);
}

.mini-stat.premium:hover .stat-glow-bg {
  opacity: 0.8;
}

.stat-icon-halo {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.stat-icon-halo.workers {
  color: #10b981;
  border-color: rgba(16, 185, 129, 0.2);
}

.stat-icon-halo.performance {
  color: #f59e0b;
  border-color: rgba(245, 158, 11, 0.2);
}

.stat-icon-halo.speed {
  color: #6366f1;
  border-color: rgba(99, 102, 241, 0.2);
}

.mini-stat.premium:hover .stat-icon-halo {
  transform: rotate(-10deg) scale(1.1);
  background: rgba(255, 255, 255, 0.08);
}

.dashboard-font {
  font-family: 'Inter', 'Outfit', sans-serif;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.05em !important;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.1);
}

.mini-val-row .pulse-dot.active {
  width: 8px;
  height: 8px;
  background: #10b981;
  box-shadow: 0 0 12px #10b981;
}

.stat-hint {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 700;
  margin-top: 0.75rem;
  opacity: 0.4;
  transition: opacity 0.3s ease;
}

.mini-stat.premium:hover .stat-hint {
  opacity: 0.8;
}

/* Light Mode Overrides for Premium Stats */
html[data-theme="light"] .mini-stats-row.premium {
  background: rgba(248, 250, 252, 0.8);
}

html[data-theme="light"] .mini-stat.premium {
  background: #ffffff;
  border-color: rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
}

html[data-theme="light"] .stat-glow-bg {
  opacity: 0.05;
}

html[data-theme="light"] .mini-stat.premium:hover {
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  border-color: rgba(99, 102, 241, 0.2);
}

html[data-theme="light"] .stat-icon-halo {
  background: rgba(0, 0, 0, 0.02);
  border-color: rgba(0, 0, 0, 0.03);
}

/* Monitor Section Decorative Elements */
.section-container.monitor-view {
  position: relative;
  overflow: hidden;
}

.monitor-bg-glow {
  position: absolute;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, transparent 70%);
  filter: blur(60px);
  z-index: -1;
  pointer-events: none;
}

.glow-top-right {
  top: -100px;
  right: -100px;
}

.glow-bottom-left {
  bottom: -100px;
  left: -100px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.stat-card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(99, 102, 241, 0.3);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.monitor-card {
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);
  border-radius: 28px;
  overflow: hidden;
  transition: border-color 0.4s ease;
  position: relative;
}

.logs-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(18, 16, 16, 0) 50%,
      rgba(0, 0, 0, 0.1) 50%), linear-gradient(90deg,
      rgba(255, 0, 0, 0.02),
      rgba(0, 255, 0, 0.01),
      rgba(0, 0, 255, 0.02));
  background-size: 100% 4px, 3px 100%;
  pointer-events: none;
  z-index: 5;
  opacity: 0.3;
}

.monitor-card:hover {
  border-color: rgba(99, 102, 241, 0.2);
}

/* Redundant log styles removed to use unified block at the top */

.charts-content {
  padding: 1.5rem;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 0.5rem;
  /* Added gap to bring items closer */
  min-height: 0;
}

.throughput-svg text {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  opacity: 0.6;
}

.mini-stat {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.01));
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.pulse-dot {
  background: #10b981;
  box-shadow: 0 0 15px #10b981, 0 0 30px rgba(16, 185, 129, 0.4);
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }

  100% {
    transform: translateY(0px);
  }
}

.btn-resume-scroll {
  position: sticky;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  background: var(--primary);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.4);
  animation: fadeIn 0.3s ease;
}

/* .btn-resume-scroll:hover {
  background: #4f46e5;
  transform: translateX(-50%) translateY(-2px);
} */

/* Jobs Grid */
.job-status {
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
}

.job-status.completed {
  background: rgba(16, 185, 129, 0.15);
  color: #34d399;
}

.job-status.in-progress {
  background: rgba(99, 102, 241, 0.15);
  color: #818cf8;
}

.job-status.failed {
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
}

/* Stats (Monitor Section) */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.stat-card {
  background: var(--card-bg);
  backdrop-filter: blur(12px);
  border: 1px solid var(--card-border);
  border-radius: 20px;
  padding: 1.5rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 1.25rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at top right, rgba(255, 255, 255, 0.03), transparent);
  pointer-events: none;
}

.stat-card:hover {
  background: var(--card-hover-bg);
  border-color: rgba(99, 102, 241, 0.4);
  transform: translateY(-8px);
  box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.4);
}

.stat-card:hover .stat-icon {
  animation: icon-pop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

.stat-icon.primary {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(99, 102, 241, 0.05));
  color: #818cf8;
}

.stat-icon.success {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.2), rgba(16, 185, 129, 0.05));
  color: #34d399;
}

.stat-icon.error {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.2), rgba(239, 68, 68, 0.05));
  color: #f87171;
}

.stat-icon.purple {
  background: linear-gradient(135deg, rgba(168, 85, 247, 0.2), rgba(168, 85, 247, 0.05));
  color: #a78bfa;
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 0 12px rgba(255, 255, 255, 0.02);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-icon::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
  pointer-events: none;
}

.stat-icon.total {
  background: rgba(99, 102, 241, 0.1);
  color: #6366f1;
}

.stat-icon.running {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.stat-icon.completed {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.stat-icon.failed {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.stat-icon.success {
  background: rgba(168, 85, 247, 0.1);
  color: #a855f7;
}

.stat-icon.cancelled {
  background: rgba(245, 158, 11, 0.1);
  color: #fbbf24;
}

.stat-icon.data {
  background: rgba(168, 85, 247, 0.1);
  color: #a78bfa;
}

/* Light Theme overrides for visibility */
html[data-theme="light"] .stat-icon.total {
  background: rgba(99, 102, 241, 0.2);
  color: #4f46e5;
}

html[data-theme="light"] .stat-icon.running {
  background: rgba(59, 130, 246, 0.2);
  color: #2563eb;
}

html[data-theme="light"] .stat-icon.completed {
  background: rgba(16, 185, 129, 0.2);
  color: #059669;
}

html[data-theme="light"] .stat-icon.cancelled {
  background: rgba(245, 158, 11, 0.2);
  color: #b45309;
}

html[data-theme="light"] .stat-icon.failed {
  background: rgba(239, 68, 68, 0.2);
  color: #dc2626;
}

html[data-theme="light"] .stat-icon.success {
  background: rgba(168, 85, 247, 0.2);
  color: #9333ea;
}

/* Light Theme Monitor Overrides - Premium Pass */
html[data-theme="light"] .monitor-card {
  background: linear-gradient(145deg, #ffffff, #f8fafc);
  border-color: rgba(0, 0, 0, 0.06);
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.05),
    0 4px 6px -2px rgba(0, 0, 0, 0.02),
    inset 0 2px 4px rgba(255, 255, 255, 0.8);
}

html[data-theme="light"] .monitor-card:hover {
  border-color: var(--primary);
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.08),
    0 10px 10px -5px rgba(0, 0, 0, 0.03);
}

html[data-theme="light"] .monitor-card-header {
  background: rgba(0, 0, 0, 0.015);
  border-bottom-color: rgba(0, 0, 0, 0.04);
  padding: 1.25rem 2rem;
}

html[data-theme="light"] .job-summary-banner {
  background: white;
  border-bottom: 2px solid #f1f5f9;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.03);
  margin: 1rem;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.03);
}

html[data-theme="light"] .job-summary-banner::after {
  height: 3px;
  border-radius: 0 0 10px 10px;
  box-shadow: none;
}

html[data-theme="light"] .log-viewer {
  background: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

html[data-theme="light"] .log-entry {
  background: transparent !important;
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
  color: #1e293b !important;
  box-shadow: none !important;
}

html[data-theme="light"] .log-entry:hover {
  background: rgba(0, 0, 0, 0.02) !important;
}

html[data-theme="light"] .log-entry .log-msg {
  color: #334155 !important;
}

html[data-theme="light"] .log-time {
  background: transparent !important;
  color: #64748b !important;
}

html[data-theme="light"] .log-badge {
  opacity: 0.8 !important;
}

html[data-theme="light"] .job-selector {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  color: #0f172a;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

html[data-theme="light"] .mini-stat {
  background: white;
  border-color: rgba(0, 0, 0, 0.04);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

html[data-theme="light"] .mini-label {
  color: #64748b;
  font-weight: 600;
}

html[data-theme="light"] .job-status.completed {
  background: #dcfce7;
  color: #166534;
}

html[data-theme="light"] .btn-resume-scroll {
  background: var(--primary);
  color: white;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.3);
}

html[data-theme="light"] .logs-section::before {
  display: none;
  /* No CRT effect in clean light mode */
}

html[data-theme="light"] .stat-card {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.1),
    0 1px 2px rgba(0, 0, 0, 0.06);
}

html[data-theme="light"] .stat-card:hover {
  border-color: var(--primary);
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.05),
    0 10px 10px -5px rgba(0, 0, 0, 0.02);
}

html[data-theme="light"] .summary-val.status-COMPLETED {
  color: #15803d !important;
}

html[data-theme="light"] .summary-val.status-RUNNING {
  color: #4338ca !important;
}

html[data-theme="light"] .summary-val.status-FAILED {
  color: #b91c1c !important;
}

html[data-theme="light"] .summary-val.status-CANCELLED {
  color: #b45309 !important;
}

html[data-theme="light"] .header-icon {
  color: var(--primary);
  filter: drop-shadow(0 2px 4px rgba(99, 102, 241, 0.15));
}

.stat-value {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1;
  margin-bottom: 0.5rem;
}

.stat-label {
  color: var(--text-muted);
  font-size: 0.9rem;
}

/* Activity Feed */
.activity-section {
  margin: 3rem 0;
}

.activity-section h3 {
  margin-bottom: 1.5rem;
  font-size: 1.25rem;
  color: var(--text-main);
}

.activity-container {
  background: var(--card-bg);
  backdrop-filter: blur(10px);
  border: 1px solid var(--card-border);
  border-radius: 16px;
  padding: 1.5rem;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.activity-item {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1rem;
  background: var(--surface-light);
  border-radius: 12px;
  border-bottom: var(--glass-border);
}

.activity-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(99, 102, 241, 0.1);
  color: #818cf8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.activity-content {
  flex: 1 1;
}

.activity-title {
  color: var(--text-main);
  font-size: 0.95rem;
  font-weight: 600;
  /* Bolder activity title */
}

.activity-time {
  color: var(--text-muted);
  font-size: 0.85rem;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .job-card {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

/* Empty State */
.empty-activity {
  text-align: center;
  padding: 4rem 2rem;
  color: var(--text-muted);
}

.empty-activity h3 {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--text-main);
  margin-bottom: 0.75rem;
}

.empty-activity p {
  font-size: 1.1rem;
  color: var(--text-muted);
}

/* Health Section */
.health-section {
  margin-top: 3rem;
}

.health-section h3 {
  margin-bottom: 1.5rem;
  font-size: 1.25rem;
  color: var(--text-main);
}

.health-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}

.health-card {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 1rem;
}

.health-card:hover {
  background: var(--card-hover-bg);
  border-color: rgba(99, 102, 241, 0.4);
  transform: translateY(-6px);
  box-shadow: 0 20px 40px -10px var(--card-shadow);
}

.health-card:hover .health-icon {
  animation: icon-pop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

.health-icon {
  font-size: 1.25rem;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  transition: all 0.3s ease;
  position: relative;
}

.health-icon.online {
  animation: pulse-glow 3s infinite;
}

.health-icon.online {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
  border-color: rgba(16, 185, 129, 0.2);
}

.health-icon.connected {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  border-color: rgba(59, 130, 246, 0.2);
}

.health-icon.ready {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
  border-color: rgba(245, 158, 11, 0.2);
}

.health-icon.active {
  background: rgba(99, 102, 241, 0.1);
  color: #6366f1;
  border-color: rgba(99, 102, 241, 0.2);
}

/* Light Mode Health Overrides */
html[data-theme="light"] .health-icon.online {
  color: #059669;
  background: rgba(16, 185, 129, 0.2);
}

html[data-theme="light"] .health-icon.connected {
  color: #2563eb;
  background: rgba(59, 130, 246, 0.2);
}

html[data-theme="light"] .health-icon.ready {
  color: #d97706;
  background: rgba(245, 158, 11, 0.2);
}

html[data-theme="light"] .health-icon.active {
  color: #4f46e5;
  background: rgba(99, 102, 241, 0.2);
}

.health-info {
  flex: 1 1;
}

.health-title {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-bottom: 0.25rem;
}

.health-status {
  font-size: 1rem;
  font-weight: 600;
  color: #34d399;
}

/* Status Colors (Jobs) */
.status-color-pending {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.15);
}

.status-color-running {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.15);
}

.status-color-completed {
  color: #10b981;
  background: rgba(16, 185, 129, 0.15);
}

.status-color-failed {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.15);
}

.status-color-cancelled {
  color: #9ca3af;
  background: rgba(107, 114, 128, 0.15);
}

/* Light Mode Status Colors (Jobs) - Darker Text */
html[data-theme="light"] .status-color-pending {
  color: #d97706;
  background: rgba(245, 158, 11, 0.2);
}

html[data-theme="light"] .status-color-running {
  color: #2563eb;
  background: rgba(59, 130, 246, 0.2);
}

html[data-theme="light"] .status-color-completed {
  color: #059669;
  background: rgba(16, 185, 129, 0.2);
}

html[data-theme="light"] .status-color-failed {
  color: #dc2626;
  background: rgba(239, 68, 68, 0.2);
}

html[data-theme="light"] .status-color-cancelled {
  color: #4b5563;
  background: rgba(107, 114, 128, 0.2);
}

/* Warnings */
/* Warnings */
.warning-message {
  padding: 1rem 1.5rem;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  color: var(--text-main);
  border-radius: 12px;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  font-weight: 500;
  backdrop-filter: blur(10px);
  animation: slideIn 0.3s ease-out;
}

html[data-theme="light"] .warning-message {
  background: rgba(245, 158, 11, 0.15);
  color: #c2410c;
  /* Dark orange for readability */
  border-color: rgba(245, 158, 11, 0.4);
}

/* Empty State (General) */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background: var(--card-bg);
  backdrop-filter: blur(10px);
  border: 1px dashed var(--card-border);
  border-radius: 16px;
  color: var(--text-muted);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.empty-state:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(99, 102, 241, 0.3);
}

.empty-icon {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  opacity: 0.8;
  filter: drop-shadow(0 0 15px rgba(99, 102, 241, 0.4));
  animation: float 3s ease-in-out infinite;
}

.empty-state h3 {
  font-size: 1.5rem;
  color: var(--text-main);
  margin: 0 0 0.5rem 0;
}

.empty-state p {
  color: var(--text-muted);
  margin-bottom: 2rem;
  font-size: 1rem;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

/* Modals */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: flex-start;
  /* Changed from center to ensure top gap */
  justify-content: center;
  padding: 100px 2rem 2rem;
  /* Increased top padding to clear 70px header */
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
  overflow-y: auto;
  /* Allow overlay to scroll if modal is tall */
}

html[data-theme="light"] .modal-overlay {
  background: rgba(0, 0, 0, 0.2);
}

.modal {
  background: var(--surface);
  backdrop-filter: blur(16px);
  border: 1px solid var(--card-border);
  border-radius: 24px;
  width: 90%;
  max-width: 600px;
  box-shadow: 0 25px 70px -10px rgba(0, 0, 0, 0.6);
  animation: scaleIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  overflow: hidden;
}

html[data-theme="light"] .modal {
  box-shadow: 0 25px 70px -10px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.modal form {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.modal-header {
  padding: 1.5rem;
  border-bottom: var(--glass-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: var(--text-main);
}

.modal-close {
  background: transparent;
  border: none;
  color: var(--text-muted);
  font-size: 1.5rem;
  cursor: pointer;
  transition: color 0.2s;
  padding: 0.25rem;
  line-height: 1;
}

.modal-close:hover {
  color: var(--primary);
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1 1;
}

.modal-footer {
  padding: 1.5rem;
  border-top: var(--glass-border);
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Forms */
.form-group {
  margin-bottom: 1.25rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-muted);
  margin-bottom: 0.5rem;
}

input:not([type="checkbox"]),
select {
  width: 100%;
  padding: 0.875rem 1rem;
  background: var(--surface-light);
  border: 1px solid var(--card-border);
  border-radius: 10px;
  color: var(--text-main);
  font-size: 0.95rem;
  transition: all 0.2s;
}

select option {
  background: var(--background);
  color: var(--text-main);
}

input:not([type="checkbox"]):focus,
select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

/* Autofill styling fix */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--text-main);
  -webkit-box-shadow: 0 0 0px 1000px var(--surface-light) inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
  border: 1px solid var(--card-border);
}

::placeholder {
  color: var(--text-muted);
}

.checkbox-group {
  margin: 1.5rem 0;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  color: var(--text-main);
}

input[type="checkbox"] {
  width: 14px !important;
  height: 14px !important;
  min-width: 14px !important;
  min-height: 14px !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  accent-color: #6366f1;
}

/* Migration Preview (Modal) */
.migration-preview {
  background: rgba(15, 23, 42, 0.5);
  border-radius: 12px;
  padding: 1rem;
  margin-top: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.migration-preview h4 {
  margin: 0 0 1rem 0;
  color: var(--text-muted);
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.preview-path {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.05);
  padding: 1.25rem 1.5rem;
  border-radius: 12px;
  gap: 1rem;
}

.preview-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1 1;
}

.preview-item:last-child {
  justify-content: flex-end;
}

.preview-logo {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  min-width: 32px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 0;
  overflow: hidden;
}

.preview-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.connection-name {
  font-weight: 700;
  color: var(--text-main);
  font-size: 1rem;
}

html[data-theme="light"] .preview-logo {
  background: #f1f5f9;
  border-color: #e2e8f0;
}

html[data-theme="light"] .placeholder {
  color: #94a3b8;
  font-weight: 600;
}

.arrow {
  color: #6366f1;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  animation: arrowPulse 2s infinite ease-in-out;
}

@keyframes arrowPulse {

  0%,
  100% {
    transform: translateX(0);
    opacity: 0.6;
  }

  50% {
    transform: translateX(4px);
    opacity: 1;
    filter: drop-shadow(0 0 5px rgba(99, 102, 241, 0.5));
  }
}

/* Light Theme Overrides for Migration Preview */
html[data-theme="light"] .migration-preview {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
}

html[data-theme="light"] .migration-preview h4 {
  color: #64748b;
  font-weight: 700;
}

html[data-theme="light"] .preview-path {
  background: white;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

html[data-theme="light"] .source-name,
html[data-theme="light"] .target-name {
  color: #1e293b;
  font-weight: 700;
}

/* Migration Job Summary Banner */
.job-summary-banner {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 1rem;
  padding: 1.25rem 2rem;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.8) 0%, rgba(15, 23, 42, 0.95) 100%);
  border-bottom: 1px solid rgba(99, 102, 241, 0.2);
  position: relative;
  z-index: 10;
  backdrop-filter: blur(20px);
}


.summary-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.summary-label-group {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
}

.summary-icon {
  color: var(--primary);
  opacity: 0.8;
}

.summary-label {
  font-size: 0.75rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
}

.summary-val {
  font-size: 1.1rem;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: var(--text-main);
  letter-spacing: -0.01em;
}

.summary-val.status-COMPLETED {
  color: #10b981;
}

.summary-val.status-RUNNING {
  color: #6366f1;
}

.summary-val.status-FAILED {
  color: #ef4444;
}

.summary-val.status-CANCELLED {
  color: #f59e0b;
}

.summary-val.status-PENDING {
  color: #fbbf24;
}

.empty-logs {
  padding: 4rem 2rem;
  text-align: center;
}

.empty-icon {
  margin-bottom: 1.5rem;
  color: var(--text-muted);
  opacity: 0.3;
}

.empty-logs h3 {
  color: var(--text-main);
  margin-bottom: 0.75rem;
}

.empty-logs p {
  color: var(--text-muted);
  max-width: 400px;
  margin: 0 auto;
}

/* Discovery Dropdown Styles */
.discovery-wrapper {
  position: relative;
  width: 100%;
}

.discovery-wrapper input {
  padding-right: 40px !important;
  /* Make room for the chevron */
}

.discovery-chevron {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2;
  opacity: 0.4;
}

.discovery-wrapper:focus-within .discovery-chevron {
  opacity: 1;
  color: #6366f1;
}

.discovery-wrapper.open .discovery-chevron {
  transform: translateY(-50%) rotate(180deg);
  color: #6366f1;
  opacity: 1;
}

.discovery-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(99, 102, 241, 0.3);
  border-radius: 12px;
  max-height: 240px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.6),
    0 0 15px rgba(99, 102, 241, 0.1);
  animation: slideInDown 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  padding: 0.5rem;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.discovery-option {
  padding: 0.8rem 1rem;
  font-size: 0.9rem;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.25s ease;
  border-radius: 8px;
  margin-bottom: 2px;
}

.discovery-option:last-child {
  margin-bottom: 0;
}

.discovery-option svg {
  color: #6366f1;
  opacity: 0.6;
  transition: transform 0.3s ease;
}

.discovery-option:hover {
  background: rgba(99, 102, 241, 0.15);
  color: white;
  padding-left: 1.25rem;
}

.discovery-option:hover svg {
  opacity: 1;
  transform: scale(1.1);
}

.discovery-option.active {
  background: rgba(99, 102, 241, 0.25);
  color: #818cf8;
  font-weight: 700;
  box-shadow: inset 0 0 10px rgba(99, 102, 241, 0.1);
}

.discovery-dropdown::-webkit-scrollbar {
  width: 5px;
}

.discovery-dropdown::-webkit-scrollbar-track {
  background: transparent;
}

.discovery-dropdown::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.2);
  border-radius: 10px;
}

.discovery-dropdown::-webkit-scrollbar-thumb:hover {
  background: rgba(99, 102, 241, 0.4);
}

/* Light Theme Discovery Overrides */
html[data-theme="light"] .discovery-dropdown {
  background: rgba(255, 255, 255, 0.95);
  border-color: #e2e8f0;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
}

html[data-theme="light"] .discovery-option {
  color: #475569;
}

html[data-theme="light"] .discovery-option:hover {
  background: #f1f5f9;
  color: #1e293b;
}

html[data-theme="light"] .discovery-option.active {
  background: #e0e7ff;
  color: #4338ca;
}


/* ── Enterprise Observability Dashboard (AWS-Style) ───────────────────────── */
:root {
  --obs-bg: #0f172a;
  --obs-card-bg: rgba(30, 41, 59, 0.4);
  --obs-primary: #818cf8;
  --obs-success: #10b981;
  --obs-error: #ef4444;
  --obs-warning: #f59e0b;
  --obs-info: #0ea5e9;
  --obs-text-muted: #94a3b8;
  --obs-grid-line: rgba(255, 255, 255, 0.05);
  --obs-success-glow: rgba(16, 185, 129, 0.2);
}

html[data-theme="light"] {
  --obs-bg: #f8fafc;
  --obs-card-bg: #ffffff;
  --obs-primary: #4f46e5;
  --obs-success: #059669;
  --obs-error: #dc2626;
  --obs-warning: #d97706;
  --obs-info: #0284c7;
  --obs-text-muted: #64748b;
  --obs-grid-line: rgba(0, 0, 0, 0.05);
  --obs-success-glow: rgba(5, 150, 105, 0.1);
}

.enterprise-dashboard {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0.5rem;
  flex-shrink: 0;
}

.enterprise-job-banner {
  background: var(--obs-card-bg);
  border: 1px solid var(--grid-line);
  padding: 1.25rem 1.5rem;
  border-radius: 12px;
  backdrop-filter: blur(8px);
}

.enterprise-job-identity {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.enterprise-job-name {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-main);
}

.enterprise-job-badge {
  padding: 0.25rem 0.6rem;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.enterprise-job-duration {
  font-size: 0.85rem;
  color: var(--obs-text-muted);
  display: flex;
  align-items: center;
  gap: 4px;
}

.enterprise-job-hint {
  font-size: 0.75rem;
  color: var(--obs-text-muted);
  font-style: italic;
  margin-left: auto;
}

/* 1. Summary Metrics Header */
.metrics-header {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.metric-card {
  background: var(--obs-card-bg);
  border: 1px solid var(--grid-line);
  padding: 1.25rem;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.metric-card:hover {
  transform: translateY(-2px);
  border-color: var(--obs-primary);
  box-shadow: 0 10px 20px -10px rgba(0, 0, 0, 0.3);
}

.metric-label {
  font-size: 0.8rem;
  color: var(--obs-text-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.metric-value-row {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.metric-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-main);
}

.metric-unit {
  font-size: 0.85rem;
  color: var(--obs-text-muted);
}

.metric-trend {
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  width: fit-content;
}

.trend-up {
  color: var(--obs-success);
  background: var(--obs-success-glow);
}

.trend-down {
  color: var(--obs-error);
  background: rgba(239, 68, 68, 0.1);
}

/* 2. Main Telemetry Grid */
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1.5rem;
}

.panel-card {
  background: var(--obs-card-bg);
  border: 1px solid var(--grid-line);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}

.panel-span-4 {
  grid-column: span 4;
}

.panel-span-6 {
  grid-column: span 6;
}

.panel-span-8 {
  grid-column: span 8;
}

.panel-span-12 {
  grid-column: span 12;
}

.panel-header {
  padding: 1rem 1.5rem;
  background: rgba(255, 255, 255, 0.02);
  border-bottom: 1px solid var(--grid-line);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-main);
}

.panel-content {
  padding: 1.5rem;
  flex: 1 1;
}

/* Table Monitor */
.table-monitor {
  width: 100%;
  border-collapse: collapse;
}

.table-monitor th {
  text-align: left;
  padding: 0.75rem 1rem;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--obs-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid var(--grid-line);
}

.table-monitor td {
  padding: 1rem;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--grid-line);
  color: var(--text-main);
}

/* Resource Mini Grid */
.resource-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1.25rem;
}

.resource-mini-chart {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Progress bar helpers for dashboard */
.progress-bar-wrapper {
  height: 6px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
}

html[data-theme="light"] .progress-bar-wrapper {
  background: rgba(0, 0, 0, 0.05);
}

.progress-fill {
  height: 100%;
  background: var(--obs-primary);
  border-radius: 8px;
  transition: width 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* Error Feed in Dashboard */
.error-item {
  padding: 0.75rem;
  background: rgba(239, 68, 68, 0.05);
  border: 1px solid rgba(239, 68, 68, 0.1);
  border-radius: 8px;
  margin-bottom: 0.75rem;
}

.error-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.7rem;
  margin-bottom: 0.25rem;
  color: var(--obs-text-muted);
}

.error-msg {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  word-break: break-all;
}

/* Monitor Expanded Overlay Modal */
.monitor-expanded-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.65);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease-out;
}

html[data-theme="light"] .monitor-expanded-overlay {
  background: rgba(255, 255, 255, 0.6);
}

.overlay-content {
  width: 95%;
  max-width: 1400px;
  height: 85vh;
  background: var(--surface);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--card-border);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 40px 100px -20px rgba(0, 0, 0, 0.4);
  animation: scaleIn 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

html[data-theme="light"] .overlay-content {
  box-shadow: 0 40px 100px -20px rgba(0, 0, 0, 0.1);
}

.overlay-header {
  padding: 1.25rem 2rem;
  background: transparent;
  border-bottom: 1px solid var(--grid-line);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.overlay-header .header-title h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-main);
  opacity: 0.9;
}

.close-overlay-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--surface-light);
  border: 1px solid var(--card-border);
  color: var(--text-muted);
  padding: 0.5rem 1rem;
  border-radius: 12px;
  font-weight: 500;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.close-overlay-btn:hover {
  background: var(--surface);
  color: var(--text-main);
  border-color: var(--primary);
  transform: translateY(-1px);
}

.overlay-body {
  flex: 1 1;
  padding: 1.5rem 2rem;
  overflow-y: auto;
  background: var(--background);
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

html[data-theme="light"] .overlay-body {
  background: #f1f5f9;
}

.log-viewer.expanded {
  height: 100%;
  background: var(--surface) !important;
  backdrop-filter: blur(10px);
  border: 1px solid var(--card-border);
  border-radius: 16px;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  padding: 0;
  overflow-y: auto;
  color: var(--text-main);
  box-shadow: var(--glass-shadow);
}

html[data-theme="light"] .log-viewer.expanded {
  background: #ffffff !important;
  border-color: rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.log-viewer.expanded .log-entry {
  border-bottom: 1px solid var(--grid-line);
  padding: 0.75rem 1.25rem !important;
  background: transparent !important;
  color: var(--text-main) !important;
  transition: background 0.2s ease !important;
}

html[data-theme="light"] .log-viewer.expanded .log-entry {
  border-bottom-color: rgba(0, 0, 0, 0.04);
}

.log-viewer.expanded .log-entry:nth-child(even) {
  background: rgba(255, 255, 255, 0.015) !important;
}

html[data-theme="light"] .log-viewer.expanded .log-entry:nth-child(even) {
  background: rgba(0, 0, 0, 0.01) !important;
}

.log-viewer.expanded .log-entry:hover {
  background: rgba(99, 102, 241, 0.05) !important;
}

.log-viewer.expanded .log-entry::before {
  width: 4px !important;
  opacity: 0.8 !important;
  border-radius: 0 !important;
}

.log-viewer.expanded .log-msg {
  color: var(--text-main) !important;
  line-height: 1.6 !important;
  font-size: 0.9rem !important;
}

html[data-theme="light"] .log-viewer.expanded .log-msg {
  color: #1e293b !important;
}

.log-viewer.expanded .log-time {
  color: var(--text-muted) !important;
  font-family: 'Outfit', sans-serif !important;
  font-weight: 500 !important;
  font-size: 0.75rem !important;
}

html[data-theme="light"] .log-viewer.expanded .log-time {
  color: #64748b !important;
}

.log-viewer.expanded .log-badge {
  border-radius: 20px !important;
  padding: 0.2rem 0.75rem !important;
  font-size: 0.65rem !important;
  letter-spacing: 0.05em !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Fix for overlapping elements if any */
.monitor-expanded-overlay * {
  box-sizing: border-box;
}

/* Light mode small buttons in Sections.css */
html[data-theme="light"] .btn-test {
  background: linear-gradient(135deg, rgba(79, 70, 229, 0.12) 0%, rgba(99, 102, 241, 0.12) 100%) !important;
  color: #4f46e5 !important;
  border: 1px solid rgba(99, 102, 241, 0.3) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

html[data-theme="light"] .btn-test:hover {
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%) !important;
  color: #ffffff !important;
  border-color: #4f46e5 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.35), 0 0 10px rgba(99, 102, 241, 0.15);
}

html[data-theme="light"] .btn-edit-small {
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.12) 0%, rgba(139, 92, 246, 0.12) 100%) !important;
  color: #7c3aed !important;
  border: 1px solid rgba(139, 92, 246, 0.3) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

html[data-theme="light"] .btn-edit-small:hover {
  background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%) !important;
  color: #ffffff !important;
  border-color: #7c3aed !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.35), 0 0 10px rgba(139, 92, 246, 0.15);
}

html[data-theme="light"] .btn-delete-small {
  background: linear-gradient(135deg, rgba(185, 28, 28, 0.08) 0%, rgba(220, 38, 38, 0.08) 100%) !important;
  color: #b91c1c !important;
  border: 1px solid rgba(220, 38, 38, 0.25) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

html[data-theme="light"] .btn-delete-small:hover {
  background: linear-gradient(135deg, #b91c1c 0%, #ef4444 100%) !important;
  color: #ffffff !important;
  border-color: #b91c1c !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(185, 28, 28, 0.35), 0 0 10px rgba(220, 38, 38, 0.15);
}

/* Dark mode overrides for small buttons in Sections.css */
html[data-theme="dark"] .btn-test {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(139, 92, 246, 0.06) 100%) !important;
  color: #a5b4fc !important;
  border: 1px solid rgba(99, 102, 241, 0.35) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

html[data-theme="dark"] .btn-edit-small {
  background: linear-gradient(135deg, rgba(168, 85, 247, 0.08) 0%, rgba(139, 92, 246, 0.06) 100%) !important;
  color: #c084fc !important;
  border: 1px solid rgba(168, 85, 247, 0.35) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

html[data-theme="dark"] .btn-delete-small {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.06) 0%, rgba(220, 38, 38, 0.05) 100%) !important;
  color: #f87171 !important;
  border: 1px solid rgba(239, 68, 68, 0.35) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* --- Premium Accents, Depth & Contrast Refinements (Sections.css overrides for ConnectionsSection) --- */

/* Card general styles for connection-card to matches dms-conn-card */
html[data-theme="light"] .connection-card {
  background: rgba(255, 255, 255, 0.75) !important;
  backdrop-filter: blur(24px) saturate(180%) !important;
  border: 1.5px solid transparent !important;
  background-clip: padding-box !important;
  border-radius: 24px !important;
  position: relative !important;
  z-index: 1 !important;
  box-shadow:
    0 12px 30px rgba(0, 0, 0, 0.04),
    0 4px 10px rgba(0, 0, 0, 0.02),
    inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

html[data-theme="dark"] .connection-card {
  background: rgba(10, 15, 30, 0.85) !important;
  backdrop-filter: blur(24px) saturate(180%) !important;
  border: 1.5px solid transparent !important;
  background-clip: padding-box !important;
  border-radius: 24px !important;
  position: relative !important;
  z-index: 1 !important;
  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.18),
    0 8px 18px rgba(0, 0, 0, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.connection-card:hover {
  transform: translateY(-4px) !important;
}

html[data-theme="light"] .connection-card:hover {
  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.08),
    0 8px 16px rgba(0, 0, 0, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.7) !important;
}

html[data-theme="dark"] .connection-card:hover {
  box-shadow:
    0 30px 60px rgba(0, 0, 0, 0.25),
    0 12px 24px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.12) !important;
}

/* Card Gradient Border Pseudo Elements (For default non-tested state) */
.connection-card::before {
  content: '' !important;
  position: absolute !important;
  top: -2.5px !important;
  bottom: -2.5px !important;
  left: -2.5px !important;
  right: -2.5px !important;
  border-radius: 24px !important;
  z-index: -1 !important;
  pointer-events: none !important;
  padding: 2.5px !important;
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0) !important;
  mask-composite: exclude !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  opacity: 0.7 !important;
  background: transparent !important;
}

/* Disable card background glows to avoid flooding colors inside */
.connection-card::after {
  content: none !important;
  display: none !important;
}

/* Default border gradients for cloud providers */
.connection-card:has(img[alt="GCP"])::before {
  background: linear-gradient(135deg, #06b6d4, #10b981) !important;
}

.connection-card:has(img[alt="AWS"])::before {
  background: linear-gradient(135deg, #ef4444, #ec4899) !important;
}

.connection-card:has(img[alt="Azure"])::before {
  background: linear-gradient(135deg, #8b5cf6, #6366f1) !important;
}

/* Hover border illumination */
.connection-card:hover::before {
  opacity: 1.0 !important;
}

/* Provider Circular Logo containers / Connection Icons */
.connection-icon {
  border-radius: 50% !important;
  width: 48px !important;
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.3s ease !important;
}

html[data-theme="dark"] .connection-icon {
  background: #0d1119 !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3) !important;
}

html[data-theme="light"] .connection-icon {
  background: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05) !important;
}

/* Tested State Card Surfaces and Borders */
html[data-theme="light"] .connection-card.test-success {
  background: rgba(240, 253, 250, 0.85) !important;
  border: 2.5px solid rgba(16, 185, 129, 0.8) !important;
  box-shadow: 0 10px 25px rgba(16, 185, 129, 0.05) !important;
}

html[data-theme="light"] .connection-card.test-failed {
  background: rgba(254, 242, 242, 0.85) !important;
  border: 2.5px solid rgba(239, 68, 68, 0.8) !important;
  box-shadow: 0 10px 25px rgba(239, 68, 68, 0.05) !important;
}

html[data-theme="dark"] .connection-card.test-success {
  background: rgba(10, 15, 30, 0.9) !important;
  border: 2.5px solid #10b981 !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(16, 185, 129, 0.15) !important;
}

html[data-theme="dark"] .connection-card.test-failed {
  background: rgba(10, 15, 30, 0.9) !important;
  border: 2.5px solid #ef4444 !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(239, 68, 68, 0.12) !important;
}

/* Dark Mode Card Subtle Ambient Glow Backgrounds on Tested state or provider glows */
html[data-theme="dark"] .connection-card:has(img[alt="GCP"])::before {
  background: radial-gradient(circle, rgba(6, 182, 212, 0.08) 0%, rgba(59, 130, 246, 0.02) 55%, transparent 75%) !important;
}

html[data-theme="dark"] .connection-card:has(img[alt="AWS"])::before {
  background: radial-gradient(circle, rgba(236, 72, 153, 0.08) 0%, rgba(168, 85, 247, 0.02) 55%, transparent 75%) !important;
}

/* Glassy Inner Slates / Connection Details container */
.connection-details {
  padding: 1rem !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 0.75rem !important;
  margin-top: 1rem !important;
}

html[data-theme='dark'] .connection-details {
  background: #090c15 !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 16px !important;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.35) !important;
}

html[data-theme='dark'] .detail-row {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px !important;
  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.02) !important;
  padding: 0.65rem 0.75rem !important;
  margin: 0 !important;
}

html[data-theme='dark'] .detail-row:hover {
  background: rgba(255, 255, 255, 0.06) !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
}

/* Light Mode: Inner slates / details container tinted by test state */
html[data-theme='light'] .connection-details {
  background: rgba(0, 0, 0, 0.02) !important;
  border: 1px solid rgba(0, 0, 0, 0.04) !important;
  border-radius: 16px !important;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.02) !important;
}

html[data-theme='light'] .connection-card.test-success .connection-details {
  background: rgba(209, 250, 229, 0.5) !important;
  border: 1px solid rgba(16, 185, 129, 0.15) !important;
}

html[data-theme='light'] .connection-card.test-failed .connection-details {
  background: rgba(254, 226, 226, 0.6) !important;
  border: 1px solid rgba(239, 68, 68, 0.15) !important;
}

html[data-theme='light'] .detail-row {
  background: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;
  padding: 0.65rem 0.75rem !important;
  margin: 0 !important;
}

html[data-theme='light'] .detail-row:hover {
  background: #ffffff !important;
  border-color: rgba(99, 102, 241, 0.25) !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.04) !important;
}

/* Glass Buttons Base */
.btn-test,
.btn-edit-small,
.btn-delete-small {
  background: rgba(255, 255, 255, 0.02) !important;
  backdrop-filter: blur(8px) !important;
  border-radius: 10px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-weight: 700 !important;
  font-size: 0.68rem !important;
  letter-spacing: 0.08em !important;
  text-transform: uppercase !important;
  box-shadow: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Light Mode Buttons */
html[data-theme="light"] .btn-test {
  background: rgba(99, 102, 241, 0.04) !important;
  border: 1px solid rgba(99, 102, 241, 0.35) !important;
  color: #4f46e5 !important;
}

html[data-theme="light"] .btn-test:hover {
  background: rgba(99, 102, 241, 0.1) !important;
  border-color: #4f46e5 !important;
  color: #4f46e5 !important;
  transform: translateY(-2px) !important;
}

html[data-theme="light"] .btn-edit-small {
  background: rgba(139, 92, 246, 0.04) !important;
  border: 1px solid rgba(139, 92, 246, 0.35) !important;
  color: #7c3aed !important;
}

html[data-theme="light"] .btn-edit-small:hover {
  background: rgba(139, 92, 246, 0.1) !important;
  border-color: #7c3aed !important;
  color: #7c3aed !important;
  transform: translateY(-2px) !important;
}

html[data-theme="light"] .btn-delete-small {
  background: rgba(239, 68, 68, 0.03) !important;
  border: 1px solid rgba(239, 68, 68, 0.35) !important;
  color: #dc2626 !important;
}

html[data-theme="light"] .btn-delete-small:hover {
  background: rgba(239, 68, 68, 0.08) !important;
  border-color: #dc2626 !important;
  color: #dc2626 !important;
  transform: translateY(-2px) !important;
}

/* Dark Mode Buttons (Match white text/purple border layout from photo) */
html[data-theme="dark"] .btn-test {
  background: rgba(99, 102, 241, 0.04) !important;
  border: 1px solid rgba(99, 102, 241, 0.45) !important;
  color: #ffffff !important;
}

html[data-theme="dark"] .btn-test:hover {
  background: rgba(99, 102, 241, 0.15) !important;
  border-color: #818cf8 !important;
  color: #ffffff !important;
  transform: translateY(-2px) !important;
}

html[data-theme="dark"] .btn-edit-small {
  background: rgba(139, 92, 246, 0.04) !important;
  border: 1px solid rgba(139, 92, 246, 0.45) !important;
  color: #ffffff !important;
}

html[data-theme="dark"] .btn-edit-small:hover {
  background: rgba(139, 92, 246, 0.15) !important;
  border-color: #a78bfa !important;
  color: #ffffff !important;
  transform: translateY(-2px) !important;
}

html[data-theme="dark"] .btn-delete-small {
  background: rgba(239, 68, 68, 0.04) !important;
  border: 1px solid rgba(239, 68, 68, 0.45) !important;
  color: #fca5a5 !important;
}

html[data-theme="dark"] .btn-delete-small:hover {
  background: rgba(239, 68, 68, 0.15) !important;
  border-color: #fda4af !important;
  color: #fca5a5 !important;
  transform: translateY(-2px) !important;
}

/* Typography readability and contrast overrides for connection cards */
html[data-theme="light"] .connection-info h3 {
  color: #090d16 !important;
  font-weight: 700 !important;
}

html[data-theme="light"] .connection-type {
  color: #52526b !important;
  font-weight: 600 !important;
}

html[data-theme="light"] .detail-label {
  color: #6b7280 !important;
  font-weight: 600 !important;
}

html[data-theme="light"] .detail-value {
  color: #0f172a !important;
  font-weight: 700 !important;
}

html[data-theme="dark"] .connection-info h3 {
  color: #ffffff !important;
  font-weight: 700 !important;
}

html[data-theme="dark"] .connection-type {
  color: #cbd5e1 !important;
  font-weight: 500 !important;
}

html[data-theme="dark"] .detail-label {
  color: #94a3b8 !important;
  font-weight: 600 !important;
}

html[data-theme="dark"] .detail-value {
  color: #ffffff !important;
  font-weight: 700 !important;
}

/* --- Draft Connection Card and Status Badge Styling --- */
html[data-theme="light"] .connection-card.draft {
  background: rgba(254, 243, 199, 0.75) !important;
  border: 2.5px solid rgba(245, 158, 11, 0.8) !important;
  box-shadow: 0 10px 25px rgba(245, 158, 11, 0.05) !important;
}

html[data-theme="dark"] .connection-card.draft {
  background: rgba(10, 15, 30, 0.9) !important;
  border: 2.5px solid #fbbf24 !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(245, 158, 11, 0.15) !important;
}

html[data-theme="light"] .status-badge-pill.draft {
  border: 1.5px solid rgba(245, 158, 11, 0.6) !important;
  color: #d97706 !important;
  background: transparent !important;
}

html[data-theme="dark"] .status-badge-pill.draft {
  border: 1px solid rgba(251, 191, 36, 0.6) !important;
  color: #fbbf24 !important;
  background: transparent !important;
}

html[data-theme='light'] .connection-card.draft .connection-details {
  background: rgba(254, 243, 199, 0.4) !important;
  border: 1px solid rgba(245, 158, 11, 0.15) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/sections/Sections.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;IACtB,4CAA4C;EAC9C;;EAEA;IACE,mBAAmB;IACnB,yCAAyC;EAC3C;AACF;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;EAClC,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,mCAAmC;EACnC,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uDAAuD;EACvD,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,iDAAiD;EACjD,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oEAAoE;AACtE;;AAEA;EACE;IACE,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kEAAkE;EAClE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,6CAA6C;EAC7C,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,wBAAwB;EACxB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,8BAA8B;EAC9B,4BAA4B;EAC5B,6DAA6D;AAC/D;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6EAA6E;EAC7E,iCAAiC;AACnC;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,uBAAuB;EACvB,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,qCAAqC;EACrC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,qCAAqC;EACrC,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oCAAoC;EACpC,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;;EAEE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;EAC/C,gCAAgC;EAChC,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;;;EAKE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;;;;EAKE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,wBAAwB;EACxB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,kFAAkF;EAClF,mCAAmC;EACnC,2BAA2B;EAC3B,2CAA2C;EAC3C,sBAAsB;EACtB,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+CAA+C;AACjD;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,4BAA4B;EAC5B,8BAA8B;EAC9B,4CAA4C;EAC5C,0BAA0B;EAC1B,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,oCAAoC;EACpC,iCAAiC;EACjC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,oBAAkB;EAClB,2CAA2C;EAC3C,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,IAAI;AACN;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;EAC3C;;6CAE2C;EAC3C,gBAAgB;EAChB,mDAAmD;EACnD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qGAAqG;EACrG,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAO;EACP,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,uCAAuC;EACvC;;4CAE0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;EAC3C,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iFAAiF;EACjF,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kDAAkD;EAClD,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;4BAI0B;EAC1B,mCAAmC;EACnC,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iEAAiE;;AAEjE;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yFAAyF;EACzF,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,8DAA8D;AAChE;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,WAAW;EACX,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;;;GAGG;;AAEH,cAAc;AACd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wFAAwF;EACxF,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,sFAAsF;EACtF,cAAc;AAChB;;AAEA;EACE,sFAAsF;EACtF,cAAc;AAChB;;AAEA;EACE,oFAAoF;EACpF,cAAc;AAChB;;AAEA;EACE,sFAAsF;EACtF,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,oDAAoD;EACpD,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kFAAkF;EAClF,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,qDAAqD;EACrD,iCAAiC;EACjC;;;4CAG0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B;;wCAEsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,+CAA+C;EAC/C,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,uDAAuD;EACvD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC;;iCAE+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B;;wCAEsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA,kDAAkD;AAClD;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,aAAa;AACb,aAAa;AACb;EACE,oBAAoB;EACpB,mCAAmC;EACnC,yCAAyC;EACzC,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,uBAAuB;EACvB,wBAAwB;EACxB,+CAA+C;EAC/C,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gDAAgD;EAChD,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,UAAU;AACV;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA,yBAAyB;AACzB;;;;;;;;;EASE,yCAAyC;EACzC,6DAA6D;EAC7D,yDAAiD;EAAjD,iDAAiD;EACjD,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;EAEE;;IAEE,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,UAAU;IACV,oDAAoD;EACtD;AACF;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;EACrB,0FAA0F;EAC1F,gDAAgD;EAChD,kBAAkB;EAClB,WAAW;EACX,2BAA2B;AAC7B;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;EACpB,iDAAiD;EACjD,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb;oCACkC;EAClC,yDAAyD;EACzD,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;EACrC,qBAAqB;EACrB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA,gFAAgF;AAChF;EACE,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,SAAO;AACT;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iDAAiD;EACjD,0DAA0D;AAC5D;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,qDAAqD;EACrD,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE,yGAAyG;EACzG,yBAAyB;EACzB,oDAAoD;EACpD,6DAA6D;AAC/D;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,iFAAiF;AACnF;;AAEA;EACE,0GAA0G;EAC1G,yBAAyB;EACzB,oDAAoD;EACpD,6DAA6D;AAC/D;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,kFAAkF;AACpF;;AAEA;EACE,wGAAwG;EACxG,yBAAyB;EACzB,oDAAoD;EACpD,6DAA6D;AAC/D;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA,0DAA0D;AAC1D;EACE,0GAA0G;EAC1G,yBAAyB;EACzB,qDAAqD;EACrD,6DAA6D;AAC/D;;AAEA;EACE,0GAA0G;EAC1G,yBAAyB;EACzB,qDAAqD;EACrD,6DAA6D;AAC/D;;AAEA;EACE,wGAAwG;EACxG,yBAAyB;EACzB,oDAAoD;EACpD,6DAA6D;AAC/D;;AAEA,0GAA0G;;AAE1G,qEAAqE;AACrE;EACE,gDAAgD;EAChD,qDAAqD;EACrD,0CAA0C;EAC1C,uCAAuC;EACvC,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB;;;qDAGmD;EACnD,4DAA4D;AAC9D;;AAEA;EACE,6CAA6C;EAC7C,qDAAqD;EACrD,0CAA0C;EAC1C,uCAAuC;EACvC,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB;;;sDAGoD;EACpD,4DAA4D;AAC9D;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;;;qDAGmD;AACrD;;AAEA;EACE;;;sDAGoD;AACtD;;AAEA,wEAAwE;AACxE;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,yFAAyF;EAEzF,kCAAkC;EAClC,4DAA4D;EAC5D,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,kEAAkE;AAClE;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,sDAAsD;EACtD,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,gDAAgD;EAChD,qDAAqD;AACvD;;AAEA,2CAA2C;AAC3C;EACE,gDAAgD;EAChD,sDAAsD;EACtD,2DAA2D;AAC7D;;AAEA;EACE,gDAAgD;EAChD,qDAAqD;EACrD,0DAA0D;AAC5D;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;EACtC,yFAAyF;AAC3F;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;EACtC,wFAAwF;AAC1F;;AAEA,qFAAqF;AACrF;EACE,yHAAyH;AAC3H;;AAEA;EACE,0HAA0H;AAC5H;;AAEA,uDAAuD;AACvD;EACE,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,sDAAsD;EACtD,8BAA8B;EAC9B,0DAA0D;AAC5D;;AAEA;EACE,gDAAgD;EAChD,sDAAsD;EACtD,8BAA8B;EAC9B,gEAAgE;EAChE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA,sEAAsE;AACtE;EACE,0CAA0C;EAC1C,gDAAgD;EAChD,8BAA8B;EAC9B,0DAA0D;AAC5D;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;EAC/C,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,gDAAgD;EAChD,8BAA8B;EAC9B,oDAAoD;EACpD,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,iDAAiD;EACjD,oDAAoD;AACtD;;AAEA,uBAAuB;AACvB;;;EAGE,gDAAgD;EAChD,qCAAqC;EACrC,8BAA8B;EAC9B,4DAA4D;EAC5D,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;EAC9C,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,yEAAyE;AACzE;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,gCAAgC;EAChC,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,gCAAgC;EAChC,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;EAC9C,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,uEAAuE;AACvE;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,gDAAgD;EAChD,sDAAsD;EACtD,2DAA2D;AAC7D;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;EACtC,yFAAyF;AAC3F;;AAEA;EACE,sDAAsD;EACtD,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;AACvD","sourcesContent":["/* Sections Styles - Dark Premium */\n\n.section-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  animation: fadeInUp 0.5s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spin-smooth {\n  animation: spin 3s linear infinite;\n}\n\n@keyframes pulse-glow {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);\n  }\n\n  70% {\n    transform: scale(1.05);\n    box-shadow: 0 0 0 10px rgba(16, 185, 129, 0);\n  }\n\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);\n  }\n}\n\n@keyframes float-subtle {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-5px);\n  }\n}\n\n@keyframes icon-pop {\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.2) rotate(5deg);\n  }\n\n  100% {\n    transform: scale(1.1) rotate(0deg);\n  }\n}\n\n.section-header {\n  margin-bottom: 2.5rem;\n  padding-bottom: 1rem;\n  border-bottom: var(--glass-border);\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.header-title-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.section-header h2 {\n  font-size: 2.8rem;\n  font-weight: 850;\n  margin: 0;\n  letter-spacing: -0.04em;\n  line-height: 1;\n  background: var(--gradient-heading);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.header-subtitle {\n  margin: 0;\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n  opacity: 0.8;\n}\n\nhtml[data-theme=\"light\"] .section-header {\n  border-bottom-color: rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme=\"light\"] .section-header h2 {\n  background: linear-gradient(to right, #0f172a, #64748b);\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n\nhtml[data-theme=\"light\"] .btn-secondary {\n  background: white;\n  border-color: rgba(0, 0, 0, 0.1);\n  color: #1e293b;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme=\"light\"] .btn-secondary:hover {\n  background: #f8fafc;\n  border-color: rgba(0, 0, 0, 0.15);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.chart-bar {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  opacity: 0.8;\n}\n\n.chart-bar:hover {\n  opacity: 1;\n  filter: brightness(1.2) drop-shadow(0 0 5px rgba(16, 185, 129, 0.5));\n}\n\n@keyframes barGrow {\n  from {\n    height: 0;\n    transform: translateY(100%);\n  }\n\n  to {\n    height: var(--final-height);\n    transform: translateY(0);\n  }\n}\n\n.charts-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.chart-wrapper {\n  position: relative;\n  min-height: 240px;\n  /* Reduced from 280px */\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  /* Reduced from 1.5rem */\n  padding: 0.5rem;\n  /* Reduced from 1rem */\n}\n\n/* Connect Button (generic) */\n.btn-primary {\n  padding: 0.75rem 1.75rem;\n  background: var(--gradient-main);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-primary::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(rgba(255, 255, 255, 0.1), transparent);\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.6);\n}\n\n.btn-primary:hover::after {\n  opacity: 1;\n}\n\n.btn-primary:active {\n  transform: translateY(0) scale(0.97);\n}\n\n/* Migration Jobs (Beautified Collapsible Design) */\n.jobs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 0.5rem;\n}\n\n.migration-box {\n  background: var(--card-bg);\n  backdrop-filter: blur(14px);\n  border: 1px solid var(--card-border);\n  border-radius: 16px;\n  position: relative;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n/* Premium \"Internal Border\" */\n.migration-box::before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  right: 8px;\n  bottom: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.03);\n  border-radius: 12px;\n  pointer-events: none;\n  z-index: 1;\n}\n\n/* Premium \"L-Shaped\" Depth */\n.migration-box::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: -10px;\n  bottom: -10px;\n  border-right: 1.5px solid var(--card-border);\n  border-bottom: 1.5px solid var(--card-border);\n  border-radius: 20px;\n  z-index: -1;\n  opacity: 0.4;\n  transition: all 0.4s ease;\n  pointer-events: none;\n}\n\n.migration-box:hover {\n  transform: translateY(-4px);\n  border-color: rgba(99, 102, 241, 0.4);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);\n}\n\n.migration-box:hover::after {\n  transform: translate(4px, 4px);\n  opacity: 0.6;\n}\n\n.migration-box.expanded {\n  border-color: var(--primary);\n  background: rgba(99, 102, 241, 0.05);\n}\n\n.migration-header-compact {\n  padding: 1.25rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.migration-header-compact .main-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.migration-header-compact .name-group {\n  display: flex;\n  align-items: baseline;\n  gap: 1rem;\n}\n\n.migration-header-compact .name-group h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-main);\n  letter-spacing: -0.02em;\n}\n\n.migration-header-compact .job-id-tag {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 0.2rem 0.6rem;\n  border-radius: 6px;\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.7rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.migration-header-compact .job-id-tag .label {\n  color: var(--text-muted);\n  font-weight: 700;\n}\n\n.migration-header-compact .job-id-tag .value {\n  color: var(--primary);\n  font-weight: 700;\n}\n\n.migration-header-compact .date-group {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  opacity: 0.8;\n}\n\n.compact-speed {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: rgba(244, 114, 182, 0.1);\n  /* Pink-ish background */\n  color: #f472b6;\n  padding: 0.2rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  border: 1px solid rgba(244, 114, 182, 0.2);\n}\n\n.compact-speed .speed-icon {\n  filter: drop-shadow(0 0 3px currentColor);\n}\n\n.migration-header-compact .status-group {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  /* Reduced for better grouping */\n}\n\n.status-badge {\n  padding: 0.4rem 0.9rem;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  min-width: 120px;\n  /* Uniform width for badges */\n  justify-content: center;\n}\n\n.expand-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.03);\n  color: var(--text-muted);\n  transition: all 0.3s ease;\n  border: 1px solid transparent;\n}\n\n.migration-box:hover .expand-icon {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: var(--primary);\n}\n\n.migration-box.expanded .expand-icon {\n  color: var(--primary);\n  transform: rotate(180deg);\n}\n\n.header-actions {\n  display: flex;\n  gap: 0.75rem;\n  margin-right: 0.5rem;\n}\n\n.action-icon-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.action-icon-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.action-icon-btn.delete:hover:not(:disabled) {\n  color: #ef4444;\n  border-color: rgba(239, 68, 68, 0.4);\n  background: rgba(239, 68, 68, 0.1);\n  box-shadow: 0 0 15px rgba(239, 68, 68, 0.2);\n}\n\n.action-icon-btn.cancel:hover:not(:disabled) {\n  color: #fbbf24;\n  border-color: rgba(251, 191, 36, 0.4);\n  background: rgba(251, 191, 36, 0.1);\n  box-shadow: 0 0 15px rgba(251, 191, 36, 0.2);\n}\n\n.action-icon-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-cancel {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.8rem;\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  color: #fbbf24;\n  border-radius: 8px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-cancel:hover:not(:disabled) {\n  background: rgba(245, 158, 11, 0.2);\n  border-color: rgba(245, 158, 11, 0.5);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);\n}\n\n.btn-cancel:active {\n  transform: translateY(0);\n}\n\n.btn-cancel:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Light Mode Overrides */\nhtml[data-theme=\"light\"] .btn-cancel {\n  background: rgba(245, 158, 11, 0.1);\n  border-color: rgba(245, 158, 11, 0.3);\n  color: #b45309;\n}\n\nhtml[data-theme=\"light\"] .btn-cancel:hover:not(:disabled) {\n  background: rgba(245, 158, 11, 0.15);\n  border-color: rgba(245, 158, 11, 0.4);\n}\n\n.migration-dropdown-content {\n  padding: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 0 0 16px 16px;\n  animation: slidePanel 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n@keyframes slidePanel {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.detail-item .label {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.15em;\n  color: var(--text-muted);\n  font-weight: 700;\n}\n\n.detail-item .value {\n  font-size: 1rem;\n  color: var(--text-main);\n  font-weight: 600;\n}\n\n.detail-item .value.highlight {\n  color: #818cf8;\n  /* Indigo 400 */\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.detail-item .speed-value {\n  color: #f472b6;\n  /* Pink 400 */\n}\n\n.progress-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.mini-progress-bar {\n  height: 10px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 5px;\n  overflow: hidden;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3);\n  margin-top: 0.5rem;\n}\n\n.mini-progress-bar .progress-fill {\n  height: 100%;\n  border-radius: 5px;\n  transition: width 1s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s ease;\n  box-shadow: 0 0 10px currentColor;\n}\n\n/* Status Colors (Unified for Progress) */\n.status-color-pending {\n  color: #fbbf24 !important;\n  /* Amber 400 (Yellow) */\n  border-color: rgba(251, 191, 36, 0.3);\n  background: rgba(251, 191, 36, 0.08);\n}\n\n.status-color-running {\n  color: #fbbf24 !important;\n  /* Amber 400 (Yellow) */\n  border-color: rgba(251, 191, 36, 0.3);\n  background: rgba(251, 191, 36, 0.1);\n  box-shadow: 0 0 15px rgba(251, 191, 36, 0.1);\n}\n\n.status-color-completed {\n  color: #10b981 !important;\n  /* Emerald 500 (Green) */\n  border-color: rgba(16, 185, 129, 0.3);\n  background: rgba(16, 185, 129, 0.08);\n  box-shadow: 0 0 15px rgba(16, 185, 129, 0.1);\n}\n\n.status-color-failed {\n  color: #ef4444 !important;\n  /* Red 500 */\n  border-color: rgba(239, 68, 68, 0.3);\n  background: rgba(239, 68, 68, 0.08);\n  box-shadow: 0 0 15px rgba(239, 68, 68, 0.1);\n}\n\n.mini-progress-bar .progress-fill.status-color-pending,\n.mini-progress-bar .progress-fill.status-color-running {\n  background-color: #fbbf24 !important;\n  box-shadow: 0 0 12px rgba(251, 191, 36, 0.4);\n}\n\n.mini-progress-bar .progress-fill.status-color-completed {\n  background-color: #10b981 !important;\n  box-shadow: 0 0 12px rgba(16, 185, 129, 0.4);\n}\n\n.mini-progress-bar .progress-fill.status-color-failed {\n  background-color: #ef4444 !important;\n  box-shadow: 0 0 12px rgba(239, 68, 68, 0.4);\n}\n\n/* Light Theme Overrides */\nhtml[data-theme=\"light\"] .migration-box {\n  background: #ffffff;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme=\"light\"] .migration-dropdown-content {\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n}\n\nhtml[data-theme=\"light\"] .status-badge {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\nhtml[data-theme=\"light\"] .mini-progress-bar {\n  background: #e2e8f0;\n}\n\n/* Cards (Generic) */\n.section-card-base {\n  background: var(--card-bg);\n  border: 1px solid var(--card-border);\n  border-radius: 16px;\n  padding: 1.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.section-card-base:hover {\n  background: var(--card-hover-bg);\n  border-color: rgba(99, 102, 241, 0.4);\n  transform: translateY(-4px);\n  box-shadow: 0 20px 40px -10px var(--card-shadow);\n}\n\n/* Connections Grid */\n.connections-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1.5rem;\n}\n\n.connection-card {\n  background: var(--card-bg);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--card-border);\n  border-radius: 16px;\n  padding: 1.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.connection-card:hover {\n  background: var(--card-hover-bg);\n  border-color: rgba(99, 102, 241, 0.4);\n  transform: translateY(-4px);\n  box-shadow: 0 20px 40px -10px var(--card-shadow);\n}\n\n.connection-card.test-success {\n  background: rgba(16, 185, 129, 0.15) !important;\n  border-color: #10b981 !important;\n  backdrop-filter: blur(16px);\n  box-shadow: 0 8px 32px 0 rgba(16, 185, 129, 0.2);\n}\n\n.connection-card.test-success .connection-info h3,\n.connection-card.test-success .detail-value,\n.connection-card.test-success .detail-label,\n.connection-card.test-success .connection-type,\n.connection-card.test-success .connection-icon {\n  color: #10b981 !important;\n}\n\n.connection-card.test-success .connection-icon {\n  background: rgba(16, 185, 129, 0.2) !important;\n}\n\n.connection-card.test-failed {\n  background: rgba(239, 68, 68, 0.15) !important;\n  border-color: #ef4444 !important;\n  backdrop-filter: blur(16px);\n  box-shadow: 0 8px 32px 0 rgba(239, 68, 68, 0.2);\n}\n\n.connection-card.test-failed .connection-info h3,\n.connection-card.test-failed .detail-value,\n.connection-card.test-failed .detail-label,\n.connection-card.test-failed .connection-type,\n.connection-card.test-failed .connection-icon {\n  color: #ef4444 !important;\n}\n\n.connection-card.test-failed .connection-icon {\n  background: rgba(239, 68, 68, 0.2) !important;\n}\n\nhtml[data-theme=\"light\"] .connection-card.test-success {\n  background: #d1fae5 !important;\n  /* Emerald 100 */\n  border-color: #10b981 !important;\n}\n\nhtml[data-theme=\"light\"] .connection-card.test-success .connection-info h3,\nhtml[data-theme=\"light\"] .connection-card.test-success .detail-value,\nhtml[data-theme=\"light\"] .connection-card.test-success .detail-label,\nhtml[data-theme=\"light\"] .connection-card.test-success .connection-type,\nhtml[data-theme=\"light\"] .connection-card.test-success .connection-icon {\n  color: #065f46 !important;\n  /* Emerald 800 */\n}\n\nhtml[data-theme=\"light\"] .connection-card.test-failed {\n  background: #fee2e2 !important;\n  /* Red 100 */\n  border-color: #ef4444 !important;\n}\n\nhtml[data-theme=\"light\"] .connection-card.test-failed .connection-info h3,\nhtml[data-theme=\"light\"] .connection-card.test-failed .detail-value,\nhtml[data-theme=\"light\"] .connection-card.test-failed .detail-label,\nhtml[data-theme=\"light\"] .connection-card.test-failed .connection-type,\nhtml[data-theme=\"light\"] .connection-card.test-failed .connection-icon {\n  color: #991b1b !important;\n  /* Red 800 */\n}\n\n.connection-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.connection-icon {\n  width: 50px;\n  height: 50px;\n  flex: 0 0 50px;\n  min-width: 50px;\n  min-height: 50px;\n  border-radius: 50%;\n  padding: 0;\n  background: rgba(99, 102, 241, 0.1);\n  color: #a5b4fc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.connection-icon svg,\n.connection-icon img {\n  display: block;\n  transition: transform 0.3s ease;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.connection-card:hover .connection-icon svg,\n.connection-card:hover .connection-icon img {\n  transform: scale(1.1);\n}\n\n.connection-info h3 {\n  margin: 0;\n  color: var(--text-main);\n  font-size: 1.1rem;\n}\n\n.connection-type {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin-top: 0.25rem;\n}\n\n.provider-badge-small {\n  display: inline-block;\n  margin-top: 0.5rem;\n  padding: 0.15rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border: 1px solid transparent;\n}\n\n/* AWS Logo Fix for Dark Mode */\n.aws-logo-img {\n  filter: invert(1) hue-rotate(180deg);\n  transition: all 0.3s ease;\n  transform: scale(1.4);\n  /* Zoom in */\n}\n\nhtml[data-theme=\"light\"] .aws-logo-img {\n  filter: none;\n}\n\n.connection-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9rem;\n  padding: 0.5rem 0;\n  border-bottom: var(--glass-border);\n}\n\n.detail-label {\n  color: var(--text-muted);\n}\n\n.detail-value {\n  color: var(--text-main);\n  font-family: 'JetBrains Mono', monospace;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n/* Overhauled Connection Card Styles */\n.card-top-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.25rem;\n}\n\n.role-label {\n  font-size: 0.65rem;\n  font-weight: 800;\n  padding: 2px 8px;\n  border-radius: 6px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.role-label.role-source {\n  background: rgba(99, 102, 241, 0.1);\n  color: #818cf8;\n  border: 1px solid rgba(99, 102, 241, 0.2);\n}\n\n.role-label.role-destination {\n  background: rgba(168, 85, 247, 0.1);\n  color: #a855f7;\n  border: 1px solid rgba(168, 85, 247, 0.2);\n}\n\n.connection-name {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-main);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  letter-spacing: -0.01em;\n}\n\n.connection-subtitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.region-pill {\n  font-size: 0.6rem;\n  padding: 1px 6px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n  color: var(--text-muted);\n  font-family: 'JetBrains Mono', monospace;\n  text-transform: uppercase;\n}\n\n.connection-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.btn-test-icon,\n.btn-edit-icon,\n.btn-delete-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--card-border);\n  background: rgba(255, 255, 255, 0.03);\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.btn-test-icon:hover {\n  color: #10b981;\n  border-color: rgba(16, 185, 129, 0.4);\n  background: rgba(16, 185, 129, 0.1);\n  transform: translateY(-2px);\n}\n\n.btn-edit-icon:hover {\n  color: var(--primary-color);\n  border-color: rgba(168, 85, 247, 0.4);\n  background: rgba(168, 85, 247, 0.1);\n  transform: translateY(-2px);\n}\n\n.btn-delete-icon:hover {\n  color: #ef4444;\n  border-color: rgba(239, 68, 68, 0.4);\n  background: rgba(239, 68, 68, 0.1);\n  transform: translateY(-2px);\n}\n\n.connection-details-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.25rem;\n  margin: 1.5rem 0;\n  padding: 1.25rem;\n  background: rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.03);\n  border-radius: 14px;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.detail-item.full-width {\n  grid-column: span 2;\n}\n\n.detail-item label {\n  font-size: 0.6rem;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  opacity: 0.6;\n}\n\n.detail-item .value,\n.detail-item .value-wrap {\n  font-size: 0.85rem;\n  color: var(--text-main);\n  font-family: 'JetBrains Mono', monospace;\n  font-weight: 600;\n}\n\n.detail-item .value-wrap {\n  word-break: break-all;\n  line-height: 1.5;\n  opacity: 0.9;\n}\n\n.card-footer-provider {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.provider-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.small-logo {\n  opacity: 0.8;\n}\n\n.created-at {\n  font-size: 0.65rem;\n  color: var(--text-muted);\n  opacity: 0.5;\n}\n\n.btn-test {\n  flex: 1;\n  padding: 0.6rem;\n  background: var(--surface-light);\n  border: var(--glass-border);\n  color: var(--text-main);\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.btn-test:hover {\n  background: #10b981;\n  border-color: #059669;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\nhtml[data-theme=\"light\"] .btn-test {\n  background: rgba(0, 0, 0, 0.04);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  color: var(--text-main);\n}\n\nhtml[data-theme=\"light\"] .btn-test:hover {\n  background: #10b981;\n  color: white;\n  border-color: #059669;\n}\n\nhtml[data-theme=\"light\"] .btn-delete-small {\n  color: #dc2626;\n  background: rgba(220, 38, 38, 0.1);\n  border-color: rgba(220, 38, 38, 0.2);\n}\n\nhtml[data-theme=\"light\"] .btn-delete-small:hover {\n  background: rgba(220, 38, 38, 0.2);\n  border-color: rgba(220, 38, 38, 0.4);\n}\n\n.btn-edit-small {\n  padding: 0.6rem;\n  background: rgba(99, 102, 241, 0.1);\n  color: #a5b4fc;\n  border: 1px solid rgba(99, 102, 241, 0.2);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-edit-small:hover {\n  background: rgba(99, 102, 241, 0.2);\n  border-color: rgba(99, 102, 241, 0.4);\n}\n\nhtml[data-theme=\"light\"] .btn-edit-small {\n  color: #4f46e5;\n  background: rgba(79, 70, 229, 0.1);\n  border-color: rgba(79, 70, 229, 0.2);\n}\n\nhtml[data-theme=\"light\"] .btn-edit-small:hover {\n  background: rgba(79, 70, 229, 0.2);\n  border-color: rgba(79, 70, 229, 0.4);\n}\n\nhtml[data-theme=\"light\"] .btn-edit-small {\n  color: #4f46e5;\n  background: rgba(79, 70, 229, 0.1);\n  border-color: rgba(79, 70, 229, 0.2);\n}\n\nhtml[data-theme=\"light\"] .btn-edit-small:hover {\n  background: rgba(79, 70, 229, 0.2);\n  border-color: rgba(79, 70, 229, 0.4);\n}\n\n.btn-delete-small {\n  padding: 0.6rem;\n  background: rgba(239, 68, 68, 0.1);\n  color: #fca5a5;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-delete-small:hover {\n  background: rgba(239, 68, 68, 0.2);\n  border-color: rgba(239, 68, 68, 0.4);\n}\n\n/* Jobs Grid */\n.jobs-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n}\n\n.job-card {\n  background: var(--card-bg);\n  border: 1px solid var(--card-border);\n  border-radius: 16px;\n  padding: 1.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 2rem;\n  align-items: center;\n}\n\n.job-card:hover {\n  background: var(--card-hover-bg);\n  border-color: rgba(99, 102, 241, 0.4);\n  transform: translateY(-4px);\n  box-shadow: 0 20px 40px -10px var(--card-shadow);\n}\n\n.job-info h3 {\n  margin: 0;\n  color: var(--text-main);\n  font-size: 1.1rem;\n}\n\n.job-meta {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin-top: 0.25rem;\n}\n\n.migration-path {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.connection-box {\n  background: var(--surface-light);\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border: var(--glass-border);\n  text-align: center;\n  min-width: 140px;\n}\n\n.connection-label {\n  display: block;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 0.25rem;\n}\n\n.connection-name {\n  color: var(--text-main);\n  font-weight: 600;\n  /* Bolder name */\n}\n\n.migration-arrow {\n  color: #6366f1;\n  font-size: 1.25rem;\n}\n\n/* Monitor Section Enhancements */\n.monitor-details-grid {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr;\n  gap: 2rem;\n  margin-top: 2rem;\n  align-items: stretch;\n  /* Cards will be same height */\n}\n\n.header-icon {\n  color: var(--primary);\n  filter: drop-shadow(0 0 8px rgba(99, 102, 241, 0.4));\n}\n\n.title-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.title-group h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.subtitle {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  font-weight: 400;\n}\n\n.graph-description {\n  font-size: 0.8rem;\n  color: #94a3b8;\n  margin-top: 2px;\n  max-width: 320px;\n}\n\n.graph-legend.compact {\n  margin-top: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.02);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  font-weight: 500;\n  letter-spacing: 0.02em;\n}\n\n.legend-color {\n  width: 10px;\n  height: 3px;\n  border-radius: 2px;\n}\n\n.legend-color.speed {\n  background: var(--primary);\n  box-shadow: 0 0 10px rgba(99, 102, 241, 0.4);\n}\n\n.legend-color.events {\n  background: #10b981;\n  box-shadow: 0 0 10px rgba(16, 185, 129, 0.4);\n}\n\n.live-indicator.miniature {\n  margin-left: auto;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.05);\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid rgba(16, 185, 129, 0.1);\n}\n\nhtml[data-theme=\"light\"] .graph-description {\n  color: #64748b;\n}\n\nhtml[data-theme=\"light\"] .graph-legend.compact {\n  background: rgba(0, 0, 0, 0.02);\n  border-color: rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme=\"light\"] .legend-item {\n  color: #64748b;\n}\n\nhtml[data-theme=\"light\"] .graph-legend {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.monitor-card {\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 24px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n  height: 520px;\n  /* Fixed \"perfect\" small height */\n}\n\n.monitor-card:hover {\n  border-color: rgba(99, 102, 241, 0.3);\n  transform: translateY(-2px);\n  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);\n}\n\n.monitor-card-header {\n  padding: 1.5rem 2rem;\n  background: rgba(255, 255, 255, 0.02);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.header-title {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  color: var(--text-main);\n}\n\n.header-title h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.job-selector {\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(0, 0, 0, 0.2);\n  color: var(--text-main);\n  padding: 0.5rem 1rem;\n  border-radius: 10px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s;\n}\n\n.job-selector:hover {\n  border-color: var(--primary);\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.log-viewer {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 1.5rem;\n  background: rgba(2, 6, 23, 0.6);\n  font-family: 'JetBrains Mono', 'Fira Code', monospace;\n  font-size: 0.85rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(99, 102, 241, 0.3) transparent;\n}\n\n.log-viewer::-webkit-scrollbar {\n  width: 6px;\n}\n\n.log-viewer::-webkit-scrollbar-thumb {\n  background: rgba(99, 102, 241, 0.3);\n  border-radius: 10px;\n}\n\n.log-entry {\n  background: transparent !important;\n  border: none !important;\n  border-bottom: 1px solid var(--glass-border, rgba(255, 255, 255, 0.05)) !important;\n  padding: 0.65rem 0.75rem !important;\n  margin-bottom: 0 !important;\n  transition: background 0.2s ease !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n  position: relative !important;\n  display: flex !important;\n  flex-direction: column !important;\n  min-height: fit-content !important;\n  border-radius: 0 !important;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.log-entry:hover {\n  background: rgba(99, 102, 241, 0.04) !important;\n}\n\n/* Status indicator on the left */\n.log-entry::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  opacity: 0.6;\n}\n\n.level-info.log-entry::before {\n  background: #3b82f6;\n}\n\n.level-warn.log-entry::before {\n  background: #f59e0b;\n}\n\n.level-error.log-entry::before {\n  background: #ef4444;\n}\n\n.level-success.log-entry::before {\n  background: #10b981;\n}\n\n.log-line {\n  display: flex !important;\n  align-items: center !important;\n  gap: 1rem !important;\n  width: 100% !important;\n}\n\n.log-time {\n  color: var(--text-muted, #94a3b8) !important;\n  font-size: 0.7rem !important;\n  white-space: nowrap !important;\n  font-family: 'Outfit', sans-serif !important;\n  min-width: 80px !important;\n  opacity: 0.7 !important;\n  background: transparent !important;\n  text-align: left !important;\n}\n\n.log-badge {\n  padding: 0.15rem 0.45rem !important;\n  border-radius: 4px !important;\n  font-size: 0.65rem !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.05em !important;\n  min-width: 55px !important;\n  text-align: center !important;\n}\n\n.badge-info {\n  background: rgba(59, 130, 246, 0.1) !important;\n  color: #60a5fa !important;\n}\n\n.badge-warn {\n  background: rgba(245, 158, 11, 0.1) !important;\n  color: #fbbf24 !important;\n}\n\n.badge-error {\n  background: rgba(239, 68, 68, 0.1) !important;\n  color: #f87171 !important;\n}\n\n.badge-success {\n  background: rgba(16, 185, 129, 0.1) !important;\n  color: #34d399 !important;\n}\n\n.log-msg {\n  flex: 1 !important;\n  color: var(--text-main, #e2e8f0) !important;\n  line-height: 1.5 !important;\n  font-weight: 400 !important;\n  word-break: break-word !important;\n  font-size: 0.85rem !important;\n}\n\n.empty-logs {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  gap: 1rem;\n  opacity: 0.5;\n}\n\n.chart-canvas-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.chart-point {\n  opacity: 0;\n  cursor: help;\n  transition: opacity 0.2s, r 0.2s;\n}\n\n.chart-point:hover {\n  opacity: 1;\n  r: 6;\n}\n\n.chart-bar {\n  transition: fill 0.3s, opacity 0.3s;\n  cursor: help;\n}\n\n.chart-bar:hover {\n  opacity: 0.8;\n  fill: #34d399;\n  /* Menthe */\n}\n\n.throughput-svg {\n  width: 100%;\n  height: auto;\n  overflow: visible;\n}\n\n.chart-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  color: var(--text-muted);\n  margin-bottom: 1rem;\n  /* Reduced from 2rem */\n}\n\n.header-left-group {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.live-indicator {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.65rem;\n  font-weight: 800;\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.1);\n  padding: 0.25rem 0.6rem;\n  border-radius: 20px;\n  letter-spacing: 0.05em;\n  border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.pulse-dot {\n  width: 6px;\n  height: 6px;\n  background: #10b981;\n  border-radius: 50%;\n  animation: pulse 1.5s infinite;\n  box-shadow: 0 0 8px #10b981;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.95);\n    opacity: 0.7;\n  }\n\n  50% {\n    transform: scale(1.2);\n    opacity: 1;\n    box-shadow: 0 0 12px #10b981;\n  }\n\n  100% {\n    transform: scale(0.95);\n    opacity: 0.7;\n  }\n}\n\n.chart-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: var(--text-muted);\n  margin-bottom: 1rem;\n  /* Reduced from 2rem */\n}\n\n.chart-header h4 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.throughput-svg {\n  width: 100%;\n  height: auto;\n  overflow: visible;\n  filter: drop-shadow(0 0 10px rgba(99, 102, 241, 0.2));\n}\n\n.mini-stats-row.premium {\n  display: flex;\n  align-items: stretch;\n  gap: 1.25rem;\n  padding: 1rem 1.5rem;\n  background: rgba(2, 6, 23, 0.4);\n  border-top: 1px solid rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(10px);\n}\n\n.mini-stat.premium {\n  background: rgba(15, 23, 42, 0.5);\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow:\n    0 10px 30px -10px rgba(0, 0, 0, 0.5),\n    inset 0 1px 1px rgba(255, 255, 255, 0.05);\n  padding: 1.75rem;\n  transition: all 0.5s cubic-bezier(0.22, 1, 0.36, 1);\n  overflow: hidden;\n  position: relative;\n}\n\n.stat-glow-bg {\n  position: absolute;\n  top: -20%;\n  right: -20%;\n  width: 150px;\n  height: 150px;\n  background: radial-gradient(circle, var(--accent-color, rgba(99, 102, 241, 0.1)) 0%, transparent 70%);\n  filter: blur(40px);\n  pointer-events: none;\n  z-index: 0;\n  opacity: 0.5;\n  transition: opacity 0.5s ease;\n}\n\n.mini-stat.performance-card {\n  --accent-color: rgba(245, 158, 11, 0.15);\n}\n\n.mini-stat.speed-card {\n  --accent-color: rgba(99, 102, 241, 0.15);\n}\n\n.mini-label-group {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  z-index: 1;\n}\n\n.mini-label {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  font-weight: 800;\n  opacity: 0.7;\n}\n\n.stat-main-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1;\n  z-index: 1;\n}\n\n.mini-val-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.mini-val {\n  font-size: 2.25rem;\n  font-weight: 800;\n  background: var(--gradient-heading);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  line-height: 1;\n}\n\n.mini-val.highlight {\n  background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n\n.mini-val.success {\n  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n\n.mini-val.failed {\n  background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n\n.primary-speed {\n  display: flex;\n  align-items: baseline;\n  gap: 0.4rem;\n}\n\n.unit {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  opacity: 0.6;\n}\n\n.mini-stat.premium:hover {\n  background: rgba(30, 41, 59, 0.6);\n  border-color: rgba(255, 255, 255, 0.1);\n  transform: translateY(-8px) scale(1.02);\n  box-shadow:\n    0 20px 40px -15px rgba(0, 0, 0, 0.6),\n    inset 0 1px 1px rgba(255, 255, 255, 0.1);\n}\n\n.mini-stat.premium:hover .stat-glow-bg {\n  opacity: 0.8;\n}\n\n.stat-icon-halo {\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n}\n\n.stat-icon-halo.workers {\n  color: #10b981;\n  border-color: rgba(16, 185, 129, 0.2);\n}\n\n.stat-icon-halo.performance {\n  color: #f59e0b;\n  border-color: rgba(245, 158, 11, 0.2);\n}\n\n.stat-icon-halo.speed {\n  color: #6366f1;\n  border-color: rgba(99, 102, 241, 0.2);\n}\n\n.mini-stat.premium:hover .stat-icon-halo {\n  transform: rotate(-10deg) scale(1.1);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.dashboard-font {\n  font-family: 'Inter', 'Outfit', sans-serif;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.05em !important;\n  text-shadow: 0 0 20px rgba(255, 255, 255, 0.1);\n}\n\n.mini-val-row .pulse-dot.active {\n  width: 8px;\n  height: 8px;\n  background: #10b981;\n  box-shadow: 0 0 12px #10b981;\n}\n\n.stat-hint {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 700;\n  margin-top: 0.75rem;\n  opacity: 0.4;\n  transition: opacity 0.3s ease;\n}\n\n.mini-stat.premium:hover .stat-hint {\n  opacity: 0.8;\n}\n\n/* Light Mode Overrides for Premium Stats */\nhtml[data-theme=\"light\"] .mini-stats-row.premium {\n  background: rgba(248, 250, 252, 0.8);\n}\n\nhtml[data-theme=\"light\"] .mini-stat.premium {\n  background: #ffffff;\n  border-color: rgba(0, 0, 0, 0.05);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);\n}\n\nhtml[data-theme=\"light\"] .stat-glow-bg {\n  opacity: 0.05;\n}\n\nhtml[data-theme=\"light\"] .mini-stat.premium:hover {\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\n  border-color: rgba(99, 102, 241, 0.2);\n}\n\nhtml[data-theme=\"light\"] .stat-icon-halo {\n  background: rgba(0, 0, 0, 0.02);\n  border-color: rgba(0, 0, 0, 0.03);\n}\n\n/* Monitor Section Decorative Elements */\n.section-container.monitor-view {\n  position: relative;\n  overflow: hidden;\n}\n\n.monitor-bg-glow {\n  position: absolute;\n  width: 400px;\n  height: 400px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, transparent 70%);\n  filter: blur(60px);\n  z-index: -1;\n  pointer-events: none;\n}\n\n.glow-top-right {\n  top: -100px;\n  right: -100px;\n}\n\n.glow-bottom-left {\n  bottom: -100px;\n  left: -100px;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  padding: 1.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(99, 102, 241, 0.3);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.monitor-card {\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(24px) saturate(180%);\n  -webkit-backdrop-filter: blur(24px) saturate(180%);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);\n  border-radius: 28px;\n  overflow: hidden;\n  transition: border-color 0.4s ease;\n  position: relative;\n}\n\n.logs-section::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(rgba(18, 16, 16, 0) 50%,\n      rgba(0, 0, 0, 0.1) 50%), linear-gradient(90deg,\n      rgba(255, 0, 0, 0.02),\n      rgba(0, 255, 0, 0.01),\n      rgba(0, 0, 255, 0.02));\n  background-size: 100% 4px, 3px 100%;\n  pointer-events: none;\n  z-index: 5;\n  opacity: 0.3;\n}\n\n.monitor-card:hover {\n  border-color: rgba(99, 102, 241, 0.2);\n}\n\n/* Redundant log styles removed to use unified block at the top */\n\n.charts-content {\n  padding: 1.5rem;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  gap: 0.5rem;\n  /* Added gap to bring items closer */\n  min-height: 0;\n}\n\n.throughput-svg text {\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n  opacity: 0.6;\n}\n\n.mini-stat {\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.01));\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.pulse-dot {\n  background: #10b981;\n  box-shadow: 0 0 15px #10b981, 0 0 30px rgba(16, 185, 129, 0.4);\n}\n\n@keyframes float {\n  0% {\n    transform: translateY(0px);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n.btn-resume-scroll {\n  position: sticky;\n  bottom: 1rem;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  z-index: 10;\n  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.4);\n  animation: fadeIn 0.3s ease;\n}\n\n/* .btn-resume-scroll:hover {\n  background: #4f46e5;\n  transform: translateX(-50%) translateY(-2px);\n} */\n\n/* Jobs Grid */\n.job-status {\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.job-status.completed {\n  background: rgba(16, 185, 129, 0.15);\n  color: #34d399;\n}\n\n.job-status.in-progress {\n  background: rgba(99, 102, 241, 0.15);\n  color: #818cf8;\n}\n\n.job-status.failed {\n  background: rgba(239, 68, 68, 0.15);\n  color: #fca5a5;\n}\n\n/* Stats (Monitor Section) */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.stat-card {\n  background: var(--card-bg);\n  backdrop-filter: blur(12px);\n  border: 1px solid var(--card-border);\n  border-radius: 20px;\n  padding: 1.5rem;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle at top right, rgba(255, 255, 255, 0.03), transparent);\n  pointer-events: none;\n}\n\n.stat-card:hover {\n  background: var(--card-hover-bg);\n  border-color: rgba(99, 102, 241, 0.4);\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.4);\n}\n\n.stat-card:hover .stat-icon {\n  animation: icon-pop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n}\n\n.stat-icon.primary {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(99, 102, 241, 0.05));\n  color: #818cf8;\n}\n\n.stat-icon.success {\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.2), rgba(16, 185, 129, 0.05));\n  color: #34d399;\n}\n\n.stat-icon.error {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.2), rgba(239, 68, 68, 0.05));\n  color: #f87171;\n}\n\n.stat-icon.purple {\n  background: linear-gradient(135deg, rgba(168, 85, 247, 0.2), rgba(168, 85, 247, 0.05));\n  color: #a78bfa;\n}\n\n.stat-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: inset 0 0 12px rgba(255, 255, 255, 0.02);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.stat-icon::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);\n  pointer-events: none;\n}\n\n.stat-icon.total {\n  background: rgba(99, 102, 241, 0.1);\n  color: #6366f1;\n}\n\n.stat-icon.running {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n}\n\n.stat-icon.completed {\n  background: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n}\n\n.stat-icon.failed {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.stat-icon.success {\n  background: rgba(168, 85, 247, 0.1);\n  color: #a855f7;\n}\n\n.stat-icon.cancelled {\n  background: rgba(245, 158, 11, 0.1);\n  color: #fbbf24;\n}\n\n.stat-icon.data {\n  background: rgba(168, 85, 247, 0.1);\n  color: #a78bfa;\n}\n\n/* Light Theme overrides for visibility */\nhtml[data-theme=\"light\"] .stat-icon.total {\n  background: rgba(99, 102, 241, 0.2);\n  color: #4f46e5;\n}\n\nhtml[data-theme=\"light\"] .stat-icon.running {\n  background: rgba(59, 130, 246, 0.2);\n  color: #2563eb;\n}\n\nhtml[data-theme=\"light\"] .stat-icon.completed {\n  background: rgba(16, 185, 129, 0.2);\n  color: #059669;\n}\n\nhtml[data-theme=\"light\"] .stat-icon.cancelled {\n  background: rgba(245, 158, 11, 0.2);\n  color: #b45309;\n}\n\nhtml[data-theme=\"light\"] .stat-icon.failed {\n  background: rgba(239, 68, 68, 0.2);\n  color: #dc2626;\n}\n\nhtml[data-theme=\"light\"] .stat-icon.success {\n  background: rgba(168, 85, 247, 0.2);\n  color: #9333ea;\n}\n\n/* Light Theme Monitor Overrides - Premium Pass */\nhtml[data-theme=\"light\"] .monitor-card {\n  background: linear-gradient(145deg, #ffffff, #f8fafc);\n  border-color: rgba(0, 0, 0, 0.06);\n  box-shadow:\n    0 10px 15px -3px rgba(0, 0, 0, 0.05),\n    0 4px 6px -2px rgba(0, 0, 0, 0.02),\n    inset 0 2px 4px rgba(255, 255, 255, 0.8);\n}\n\nhtml[data-theme=\"light\"] .monitor-card:hover {\n  border-color: var(--primary);\n  box-shadow:\n    0 20px 25px -5px rgba(0, 0, 0, 0.08),\n    0 10px 10px -5px rgba(0, 0, 0, 0.03);\n}\n\nhtml[data-theme=\"light\"] .monitor-card-header {\n  background: rgba(0, 0, 0, 0.015);\n  border-bottom-color: rgba(0, 0, 0, 0.04);\n  padding: 1.25rem 2rem;\n}\n\nhtml[data-theme=\"light\"] .job-summary-banner {\n  background: white;\n  border-bottom: 2px solid #f1f5f9;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.03);\n  margin: 1rem;\n  border-radius: 16px;\n  border: 1px solid rgba(0, 0, 0, 0.03);\n}\n\nhtml[data-theme=\"light\"] .job-summary-banner::after {\n  height: 3px;\n  border-radius: 0 0 10px 10px;\n  box-shadow: none;\n}\n\nhtml[data-theme=\"light\"] .log-viewer {\n  background: #ffffff !important;\n  border: 1px solid rgba(0, 0, 0, 0.05) !important;\n}\n\nhtml[data-theme=\"light\"] .log-entry {\n  background: transparent !important;\n  border: none !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;\n  color: #1e293b !important;\n  box-shadow: none !important;\n}\n\nhtml[data-theme=\"light\"] .log-entry:hover {\n  background: rgba(0, 0, 0, 0.02) !important;\n}\n\nhtml[data-theme=\"light\"] .log-entry .log-msg {\n  color: #334155 !important;\n}\n\nhtml[data-theme=\"light\"] .log-time {\n  background: transparent !important;\n  color: #64748b !important;\n}\n\nhtml[data-theme=\"light\"] .log-badge {\n  opacity: 0.8 !important;\n}\n\nhtml[data-theme=\"light\"] .job-selector {\n  background: white;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  color: #0f172a;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme=\"light\"] .mini-stat {\n  background: white;\n  border-color: rgba(0, 0, 0, 0.04);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme=\"light\"] .mini-label {\n  color: #64748b;\n  font-weight: 600;\n}\n\nhtml[data-theme=\"light\"] .job-status.completed {\n  background: #dcfce7;\n  color: #166534;\n}\n\nhtml[data-theme=\"light\"] .btn-resume-scroll {\n  background: var(--primary);\n  color: white;\n  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.3);\n}\n\nhtml[data-theme=\"light\"] .logs-section::before {\n  display: none;\n  /* No CRT effect in clean light mode */\n}\n\nhtml[data-theme=\"light\"] .stat-card {\n  background: white;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.1),\n    0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\nhtml[data-theme=\"light\"] .stat-card:hover {\n  border-color: var(--primary);\n  box-shadow:\n    0 20px 25px -5px rgba(0, 0, 0, 0.05),\n    0 10px 10px -5px rgba(0, 0, 0, 0.02);\n}\n\nhtml[data-theme=\"light\"] .summary-val.status-COMPLETED {\n  color: #15803d !important;\n}\n\nhtml[data-theme=\"light\"] .summary-val.status-RUNNING {\n  color: #4338ca !important;\n}\n\nhtml[data-theme=\"light\"] .summary-val.status-FAILED {\n  color: #b91c1c !important;\n}\n\nhtml[data-theme=\"light\"] .summary-val.status-CANCELLED {\n  color: #b45309 !important;\n}\n\nhtml[data-theme=\"light\"] .header-icon {\n  color: var(--primary);\n  filter: drop-shadow(0 2px 4px rgba(99, 102, 241, 0.15));\n}\n\n.stat-value {\n  display: block;\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-main);\n  line-height: 1;\n  margin-bottom: 0.5rem;\n}\n\n.stat-label {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n/* Activity Feed */\n.activity-section {\n  margin: 3rem 0;\n}\n\n.activity-section h3 {\n  margin-bottom: 1.5rem;\n  font-size: 1.25rem;\n  color: var(--text-main);\n}\n\n.activity-container {\n  background: var(--card-bg);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--card-border);\n  border-radius: 16px;\n  padding: 1.5rem;\n}\n\n.activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.activity-item {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  padding: 1rem;\n  background: var(--surface-light);\n  border-radius: 12px;\n  border-bottom: var(--glass-border);\n}\n\n.activity-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(99, 102, 241, 0.1);\n  color: #818cf8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.activity-content {\n  flex: 1;\n}\n\n.activity-title {\n  color: var(--text-main);\n  font-size: 0.95rem;\n  font-weight: 600;\n  /* Bolder activity title */\n}\n\n.activity-time {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .job-card {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n}\n\n/* Empty State */\n.empty-activity {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: var(--text-muted);\n}\n\n.empty-activity h3 {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: var(--text-main);\n  margin-bottom: 0.75rem;\n}\n\n.empty-activity p {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n}\n\n/* Health Section */\n.health-section {\n  margin-top: 3rem;\n}\n\n.health-section h3 {\n  margin-bottom: 1.5rem;\n  font-size: 1.25rem;\n  color: var(--text-main);\n}\n\n.health-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n}\n\n.health-card {\n  background: var(--card-bg);\n  border: 1px solid var(--card-border);\n  border-radius: 16px;\n  padding: 1.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.health-card:hover {\n  background: var(--card-hover-bg);\n  border-color: rgba(99, 102, 241, 0.4);\n  transform: translateY(-6px);\n  box-shadow: 0 20px 40px -10px var(--card-shadow);\n}\n\n.health-card:hover .health-icon {\n  animation: icon-pop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n}\n\n.health-icon {\n  font-size: 1.25rem;\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.health-icon.online {\n  animation: pulse-glow 3s infinite;\n}\n\n.health-icon.online {\n  background: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n  border-color: rgba(16, 185, 129, 0.2);\n}\n\n.health-icon.connected {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n  border-color: rgba(59, 130, 246, 0.2);\n}\n\n.health-icon.ready {\n  background: rgba(245, 158, 11, 0.1);\n  color: #f59e0b;\n  border-color: rgba(245, 158, 11, 0.2);\n}\n\n.health-icon.active {\n  background: rgba(99, 102, 241, 0.1);\n  color: #6366f1;\n  border-color: rgba(99, 102, 241, 0.2);\n}\n\n/* Light Mode Health Overrides */\nhtml[data-theme=\"light\"] .health-icon.online {\n  color: #059669;\n  background: rgba(16, 185, 129, 0.2);\n}\n\nhtml[data-theme=\"light\"] .health-icon.connected {\n  color: #2563eb;\n  background: rgba(59, 130, 246, 0.2);\n}\n\nhtml[data-theme=\"light\"] .health-icon.ready {\n  color: #d97706;\n  background: rgba(245, 158, 11, 0.2);\n}\n\nhtml[data-theme=\"light\"] .health-icon.active {\n  color: #4f46e5;\n  background: rgba(99, 102, 241, 0.2);\n}\n\n.health-info {\n  flex: 1;\n}\n\n.health-title {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin-bottom: 0.25rem;\n}\n\n.health-status {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #34d399;\n}\n\n/* Status Colors (Jobs) */\n.status-color-pending {\n  color: #f59e0b;\n  background: rgba(245, 158, 11, 0.15);\n}\n\n.status-color-running {\n  color: #3b82f6;\n  background: rgba(59, 130, 246, 0.15);\n}\n\n.status-color-completed {\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.15);\n}\n\n.status-color-failed {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.15);\n}\n\n.status-color-cancelled {\n  color: #9ca3af;\n  background: rgba(107, 114, 128, 0.15);\n}\n\n/* Light Mode Status Colors (Jobs) - Darker Text */\nhtml[data-theme=\"light\"] .status-color-pending {\n  color: #d97706;\n  background: rgba(245, 158, 11, 0.2);\n}\n\nhtml[data-theme=\"light\"] .status-color-running {\n  color: #2563eb;\n  background: rgba(59, 130, 246, 0.2);\n}\n\nhtml[data-theme=\"light\"] .status-color-completed {\n  color: #059669;\n  background: rgba(16, 185, 129, 0.2);\n}\n\nhtml[data-theme=\"light\"] .status-color-failed {\n  color: #dc2626;\n  background: rgba(239, 68, 68, 0.2);\n}\n\nhtml[data-theme=\"light\"] .status-color-cancelled {\n  color: #4b5563;\n  background: rgba(107, 114, 128, 0.2);\n}\n\n/* Warnings */\n/* Warnings */\n.warning-message {\n  padding: 1rem 1.5rem;\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  color: var(--text-main);\n  border-radius: 12px;\n  margin-bottom: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  font-weight: 500;\n  backdrop-filter: blur(10px);\n  animation: slideIn 0.3s ease-out;\n}\n\nhtml[data-theme=\"light\"] .warning-message {\n  background: rgba(245, 158, 11, 0.15);\n  color: #c2410c;\n  /* Dark orange for readability */\n  border-color: rgba(245, 158, 11, 0.4);\n}\n\n/* Empty State (General) */\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: var(--card-bg);\n  backdrop-filter: blur(10px);\n  border: 1px dashed var(--card-border);\n  border-radius: 16px;\n  color: var(--text-muted);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.empty-state:hover {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(99, 102, 241, 0.3);\n}\n\n.empty-icon {\n  font-size: 3.5rem;\n  margin-bottom: 1.5rem;\n  opacity: 0.8;\n  filter: drop-shadow(0 0 15px rgba(99, 102, 241, 0.4));\n  animation: float 3s ease-in-out infinite;\n}\n\n.empty-state h3 {\n  font-size: 1.5rem;\n  color: var(--text-main);\n  margin: 0 0 0.5rem 0;\n}\n\n.empty-state p {\n  color: var(--text-muted);\n  margin-bottom: 2rem;\n  font-size: 1rem;\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n/* Modals */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: flex-start;\n  /* Changed from center to ensure top gap */\n  justify-content: center;\n  padding: 100px 2rem 2rem;\n  /* Increased top padding to clear 70px header */\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-out;\n  overflow-y: auto;\n  /* Allow overlay to scroll if modal is tall */\n}\n\nhtml[data-theme=\"light\"] .modal-overlay {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.modal {\n  background: var(--surface);\n  backdrop-filter: blur(16px);\n  border: 1px solid var(--card-border);\n  border-radius: 24px;\n  width: 90%;\n  max-width: 600px;\n  box-shadow: 0 25px 70px -10px rgba(0, 0, 0, 0.6);\n  animation: scaleIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  display: flex;\n  flex-direction: column;\n  max-height: 85vh;\n  overflow: hidden;\n}\n\nhtml[data-theme=\"light\"] .modal {\n  box-shadow: 0 25px 70px -10px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.modal form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.modal-header {\n  padding: 1.5rem;\n  border-bottom: var(--glass-border);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  color: var(--text-main);\n}\n\n.modal-close {\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  font-size: 1.5rem;\n  cursor: pointer;\n  transition: color 0.2s;\n  padding: 0.25rem;\n  line-height: 1;\n}\n\n.modal-close:hover {\n  color: var(--primary);\n}\n\n.modal-body {\n  padding: 1.5rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-footer {\n  padding: 1.5rem;\n  border-top: var(--glass-border);\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.95);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Forms */\n.form-group {\n  margin-bottom: 1.25rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\nlabel {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-muted);\n  margin-bottom: 0.5rem;\n}\n\ninput:not([type=\"checkbox\"]),\nselect {\n  width: 100%;\n  padding: 0.875rem 1rem;\n  background: var(--surface-light);\n  border: 1px solid var(--card-border);\n  border-radius: 10px;\n  color: var(--text-main);\n  font-size: 0.95rem;\n  transition: all 0.2s;\n}\n\nselect option {\n  background: var(--background);\n  color: var(--text-main);\n}\n\ninput:not([type=\"checkbox\"]):focus,\nselect:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n/* Autofill styling fix */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  -webkit-text-fill-color: var(--text-main);\n  -webkit-box-shadow: 0 0 0px 1000px var(--surface-light) inset;\n  transition: background-color 5000s ease-in-out 0s;\n  border: 1px solid var(--card-border);\n}\n\n::placeholder {\n  color: var(--text-muted);\n}\n\n.checkbox-group {\n  margin: 1.5rem 0;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  color: var(--text-main);\n}\n\ninput[type=\"checkbox\"] {\n  width: 14px !important;\n  height: 14px !important;\n  min-width: 14px !important;\n  min-height: 14px !important;\n  padding: 0 !important;\n  box-sizing: border-box !important;\n  accent-color: #6366f1;\n}\n\n/* Migration Preview (Modal) */\n.migration-preview {\n  background: rgba(15, 23, 42, 0.5);\n  border-radius: 12px;\n  padding: 1rem;\n  margin-top: 1.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.migration-preview h4 {\n  margin: 0 0 1rem 0;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.preview-path {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 1.25rem 1.5rem;\n  border-radius: 12px;\n  gap: 1rem;\n}\n\n.preview-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex: 1;\n}\n\n.preview-item:last-child {\n  justify-content: flex-end;\n}\n\n.preview-logo {\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  min-width: 32px;\n  min-height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  padding: 0;\n  overflow: hidden;\n}\n\n.preview-logo img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.connection-name {\n  font-weight: 700;\n  color: var(--text-main);\n  font-size: 1rem;\n}\n\nhtml[data-theme=\"light\"] .preview-logo {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n}\n\nhtml[data-theme=\"light\"] .placeholder {\n  color: #94a3b8;\n  font-weight: 600;\n}\n\n.arrow {\n  color: #6366f1;\n  font-size: 1.25rem;\n  display: flex;\n  align-items: center;\n  animation: arrowPulse 2s infinite ease-in-out;\n}\n\n@keyframes arrowPulse {\n\n  0%,\n  100% {\n    transform: translateX(0);\n    opacity: 0.6;\n  }\n\n  50% {\n    transform: translateX(4px);\n    opacity: 1;\n    filter: drop-shadow(0 0 5px rgba(99, 102, 241, 0.5));\n  }\n}\n\n/* Light Theme Overrides for Migration Preview */\nhtml[data-theme=\"light\"] .migration-preview {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\nhtml[data-theme=\"light\"] .migration-preview h4 {\n  color: #64748b;\n  font-weight: 700;\n}\n\nhtml[data-theme=\"light\"] .preview-path {\n  background: white;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme=\"light\"] .source-name,\nhtml[data-theme=\"light\"] .target-name {\n  color: #1e293b;\n  font-weight: 700;\n}\n\n/* Migration Job Summary Banner */\n.job-summary-banner {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n  gap: 1rem;\n  padding: 1.25rem 2rem;\n  background: linear-gradient(180deg, rgba(15, 23, 42, 0.8) 0%, rgba(15, 23, 42, 0.95) 100%);\n  border-bottom: 1px solid rgba(99, 102, 241, 0.2);\n  position: relative;\n  z-index: 10;\n  backdrop-filter: blur(20px);\n}\n\n\n.summary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.summary-label-group {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 2px;\n}\n\n.summary-icon {\n  color: var(--primary);\n  opacity: 0.8;\n}\n\n.summary-label {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-weight: 700;\n}\n\n.summary-val {\n  font-size: 1.1rem;\n  font-family: 'Inter', sans-serif;\n  font-weight: 700;\n  color: var(--text-main);\n  letter-spacing: -0.01em;\n}\n\n.summary-val.status-COMPLETED {\n  color: #10b981;\n}\n\n.summary-val.status-RUNNING {\n  color: #6366f1;\n}\n\n.summary-val.status-FAILED {\n  color: #ef4444;\n}\n\n.summary-val.status-CANCELLED {\n  color: #f59e0b;\n}\n\n.summary-val.status-PENDING {\n  color: #fbbf24;\n}\n\n.empty-logs {\n  padding: 4rem 2rem;\n  text-align: center;\n}\n\n.empty-icon {\n  margin-bottom: 1.5rem;\n  color: var(--text-muted);\n  opacity: 0.3;\n}\n\n.empty-logs h3 {\n  color: var(--text-main);\n  margin-bottom: 0.75rem;\n}\n\n.empty-logs p {\n  color: var(--text-muted);\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n/* Discovery Dropdown Styles */\n.discovery-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.discovery-wrapper input {\n  padding-right: 40px !important;\n  /* Make room for the chevron */\n}\n\n.discovery-chevron {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n  pointer-events: none;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 2;\n  opacity: 0.4;\n}\n\n.discovery-wrapper:focus-within .discovery-chevron {\n  opacity: 1;\n  color: #6366f1;\n}\n\n.discovery-wrapper.open .discovery-chevron {\n  transform: translateY(-50%) rotate(180deg);\n  color: #6366f1;\n  opacity: 1;\n}\n\n.discovery-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: rgba(15, 23, 42, 0.85);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(99, 102, 241, 0.3);\n  border-radius: 12px;\n  max-height: 240px;\n  overflow-y: auto;\n  z-index: 1000;\n  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.6),\n    0 0 15px rgba(99, 102, 241, 0.1);\n  animation: slideInDown 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  padding: 0.5rem;\n}\n\n@keyframes slideInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px) scale(0.98);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.discovery-option {\n  padding: 0.8rem 1rem;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: all 0.25s ease;\n  border-radius: 8px;\n  margin-bottom: 2px;\n}\n\n.discovery-option:last-child {\n  margin-bottom: 0;\n}\n\n.discovery-option svg {\n  color: #6366f1;\n  opacity: 0.6;\n  transition: transform 0.3s ease;\n}\n\n.discovery-option:hover {\n  background: rgba(99, 102, 241, 0.15);\n  color: white;\n  padding-left: 1.25rem;\n}\n\n.discovery-option:hover svg {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.discovery-option.active {\n  background: rgba(99, 102, 241, 0.25);\n  color: #818cf8;\n  font-weight: 700;\n  box-shadow: inset 0 0 10px rgba(99, 102, 241, 0.1);\n}\n\n.discovery-dropdown::-webkit-scrollbar {\n  width: 5px;\n}\n\n.discovery-dropdown::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.discovery-dropdown::-webkit-scrollbar-thumb {\n  background: rgba(99, 102, 241, 0.2);\n  border-radius: 10px;\n}\n\n.discovery-dropdown::-webkit-scrollbar-thumb:hover {\n  background: rgba(99, 102, 241, 0.4);\n}\n\n/* Light Theme Discovery Overrides */\nhtml[data-theme=\"light\"] .discovery-dropdown {\n  background: rgba(255, 255, 255, 0.95);\n  border-color: #e2e8f0;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);\n  backdrop-filter: blur(10px);\n}\n\nhtml[data-theme=\"light\"] .discovery-option {\n  color: #475569;\n}\n\nhtml[data-theme=\"light\"] .discovery-option:hover {\n  background: #f1f5f9;\n  color: #1e293b;\n}\n\nhtml[data-theme=\"light\"] .discovery-option.active {\n  background: #e0e7ff;\n  color: #4338ca;\n}\n\n\n/* ── Enterprise Observability Dashboard (AWS-Style) ───────────────────────── */\n:root {\n  --obs-bg: #0f172a;\n  --obs-card-bg: rgba(30, 41, 59, 0.4);\n  --obs-primary: #818cf8;\n  --obs-success: #10b981;\n  --obs-error: #ef4444;\n  --obs-warning: #f59e0b;\n  --obs-info: #0ea5e9;\n  --obs-text-muted: #94a3b8;\n  --obs-grid-line: rgba(255, 255, 255, 0.05);\n  --obs-success-glow: rgba(16, 185, 129, 0.2);\n}\n\nhtml[data-theme=\"light\"] {\n  --obs-bg: #f8fafc;\n  --obs-card-bg: #ffffff;\n  --obs-primary: #4f46e5;\n  --obs-success: #059669;\n  --obs-error: #dc2626;\n  --obs-warning: #d97706;\n  --obs-info: #0284c7;\n  --obs-text-muted: #64748b;\n  --obs-grid-line: rgba(0, 0, 0, 0.05);\n  --obs-success-glow: rgba(5, 150, 105, 0.1);\n}\n\n.enterprise-dashboard {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 0.5rem;\n  flex-shrink: 0;\n}\n\n.enterprise-job-banner {\n  background: var(--obs-card-bg);\n  border: 1px solid var(--grid-line);\n  padding: 1.25rem 1.5rem;\n  border-radius: 12px;\n  backdrop-filter: blur(8px);\n}\n\n.enterprise-job-identity {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.enterprise-job-name {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.enterprise-job-badge {\n  padding: 0.25rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  font-weight: 800;\n  color: #fff;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.enterprise-job-duration {\n  font-size: 0.85rem;\n  color: var(--obs-text-muted);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.enterprise-job-hint {\n  font-size: 0.75rem;\n  color: var(--obs-text-muted);\n  font-style: italic;\n  margin-left: auto;\n}\n\n/* 1. Summary Metrics Header */\n.metrics-header {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.metric-card {\n  background: var(--obs-card-bg);\n  border: 1px solid var(--grid-line);\n  padding: 1.25rem;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.metric-card:hover {\n  transform: translateY(-2px);\n  border-color: var(--obs-primary);\n  box-shadow: 0 10px 20px -10px rgba(0, 0, 0, 0.3);\n}\n\n.metric-label {\n  font-size: 0.8rem;\n  color: var(--obs-text-muted);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.metric-value-row {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.metric-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.metric-unit {\n  font-size: 0.85rem;\n  color: var(--obs-text-muted);\n}\n\n.metric-trend {\n  font-size: 0.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  width: fit-content;\n}\n\n.trend-up {\n  color: var(--obs-success);\n  background: var(--obs-success-glow);\n}\n\n.trend-down {\n  color: var(--obs-error);\n  background: rgba(239, 68, 68, 0.1);\n}\n\n/* 2. Main Telemetry Grid */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 1.5rem;\n}\n\n.panel-card {\n  background: var(--obs-card-bg);\n  border: 1px solid var(--grid-line);\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n\n.panel-span-4 {\n  grid-column: span 4;\n}\n\n.panel-span-6 {\n  grid-column: span 6;\n}\n\n.panel-span-8 {\n  grid-column: span 8;\n}\n\n.panel-span-12 {\n  grid-column: span 12;\n}\n\n.panel-header {\n  padding: 1rem 1.5rem;\n  background: rgba(255, 255, 255, 0.02);\n  border-bottom: 1px solid var(--grid-line);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.panel-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.panel-content {\n  padding: 1.5rem;\n  flex: 1;\n}\n\n/* Table Monitor */\n.table-monitor {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table-monitor th {\n  text-align: left;\n  padding: 0.75rem 1rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: var(--obs-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid var(--grid-line);\n}\n\n.table-monitor td {\n  padding: 1rem;\n  font-size: 0.85rem;\n  border-bottom: 1px solid var(--grid-line);\n  color: var(--text-main);\n}\n\n/* Resource Mini Grid */\n.resource-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 1.25rem;\n}\n\n.resource-mini-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* Progress bar helpers for dashboard */\n.progress-bar-wrapper {\n  height: 6px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\nhtml[data-theme=\"light\"] .progress-bar-wrapper {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.progress-fill {\n  height: 100%;\n  background: var(--obs-primary);\n  border-radius: 8px;\n  transition: width 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n/* Error Feed in Dashboard */\n.error-item {\n  padding: 0.75rem;\n  background: rgba(239, 68, 68, 0.05);\n  border: 1px solid rgba(239, 68, 68, 0.1);\n  border-radius: 8px;\n  margin-bottom: 0.75rem;\n}\n\n.error-meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.7rem;\n  margin-bottom: 0.25rem;\n  color: var(--obs-text-muted);\n}\n\n.error-msg {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.8rem;\n  word-break: break-all;\n}\n\n/* Monitor Expanded Overlay Modal */\n.monitor-expanded-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.65);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.3s ease-out;\n}\n\nhtml[data-theme=\"light\"] .monitor-expanded-overlay {\n  background: rgba(255, 255, 255, 0.6);\n}\n\n.overlay-content {\n  width: 95%;\n  max-width: 1400px;\n  height: 85vh;\n  background: var(--surface);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--card-border);\n  border-radius: 24px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 40px 100px -20px rgba(0, 0, 0, 0.4);\n  animation: scaleIn 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\nhtml[data-theme=\"light\"] .overlay-content {\n  box-shadow: 0 40px 100px -20px rgba(0, 0, 0, 0.1);\n}\n\n.overlay-header {\n  padding: 1.25rem 2rem;\n  background: transparent;\n  border-bottom: 1px solid var(--grid-line);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.overlay-header .header-title h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-main);\n  opacity: 0.9;\n}\n\n.close-overlay-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--surface-light);\n  border: 1px solid var(--card-border);\n  color: var(--text-muted);\n  padding: 0.5rem 1rem;\n  border-radius: 12px;\n  font-weight: 500;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.close-overlay-btn:hover {\n  background: var(--surface);\n  color: var(--text-main);\n  border-color: var(--primary);\n  transform: translateY(-1px);\n}\n\n.overlay-body {\n  flex: 1;\n  padding: 1.5rem 2rem;\n  overflow-y: auto;\n  background: var(--background);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\nhtml[data-theme=\"light\"] .overlay-body {\n  background: #f1f5f9;\n}\n\n.log-viewer.expanded {\n  height: 100%;\n  background: var(--surface) !important;\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--card-border);\n  border-radius: 16px;\n  font-family: 'JetBrains Mono', 'Fira Code', monospace;\n  padding: 0;\n  overflow-y: auto;\n  color: var(--text-main);\n  box-shadow: var(--glass-shadow);\n}\n\nhtml[data-theme=\"light\"] .log-viewer.expanded {\n  background: #ffffff !important;\n  border-color: rgba(0, 0, 0, 0.08);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\n}\n\n.log-viewer.expanded .log-entry {\n  border-bottom: 1px solid var(--grid-line);\n  padding: 0.75rem 1.25rem !important;\n  background: transparent !important;\n  color: var(--text-main) !important;\n  transition: background 0.2s ease !important;\n}\n\nhtml[data-theme=\"light\"] .log-viewer.expanded .log-entry {\n  border-bottom-color: rgba(0, 0, 0, 0.04);\n}\n\n.log-viewer.expanded .log-entry:nth-child(even) {\n  background: rgba(255, 255, 255, 0.015) !important;\n}\n\nhtml[data-theme=\"light\"] .log-viewer.expanded .log-entry:nth-child(even) {\n  background: rgba(0, 0, 0, 0.01) !important;\n}\n\n.log-viewer.expanded .log-entry:hover {\n  background: rgba(99, 102, 241, 0.05) !important;\n}\n\n.log-viewer.expanded .log-entry::before {\n  width: 4px !important;\n  opacity: 0.8 !important;\n  border-radius: 0 !important;\n}\n\n.log-viewer.expanded .log-msg {\n  color: var(--text-main) !important;\n  line-height: 1.6 !important;\n  font-size: 0.9rem !important;\n}\n\nhtml[data-theme=\"light\"] .log-viewer.expanded .log-msg {\n  color: #1e293b !important;\n}\n\n.log-viewer.expanded .log-time {\n  color: var(--text-muted) !important;\n  font-family: 'Outfit', sans-serif !important;\n  font-weight: 500 !important;\n  font-size: 0.75rem !important;\n}\n\nhtml[data-theme=\"light\"] .log-viewer.expanded .log-time {\n  color: #64748b !important;\n}\n\n.log-viewer.expanded .log-badge {\n  border-radius: 20px !important;\n  padding: 0.2rem 0.75rem !important;\n  font-size: 0.65rem !important;\n  letter-spacing: 0.05em !important;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.95);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Fix for overlapping elements if any */\n.monitor-expanded-overlay * {\n  box-sizing: border-box;\n}\n\n/* Light mode small buttons in Sections.css */\nhtml[data-theme=\"light\"] .btn-test {\n  background: linear-gradient(135deg, rgba(79, 70, 229, 0.12) 0%, rgba(99, 102, 241, 0.12) 100%) !important;\n  color: #4f46e5 !important;\n  border: 1px solid rgba(99, 102, 241, 0.3) !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\nhtml[data-theme=\"light\"] .btn-test:hover {\n  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%) !important;\n  color: #ffffff !important;\n  border-color: #4f46e5 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.35), 0 0 10px rgba(99, 102, 241, 0.15);\n}\n\nhtml[data-theme=\"light\"] .btn-edit-small {\n  background: linear-gradient(135deg, rgba(124, 58, 237, 0.12) 0%, rgba(139, 92, 246, 0.12) 100%) !important;\n  color: #7c3aed !important;\n  border: 1px solid rgba(139, 92, 246, 0.3) !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\nhtml[data-theme=\"light\"] .btn-edit-small:hover {\n  background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%) !important;\n  color: #ffffff !important;\n  border-color: #7c3aed !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.35), 0 0 10px rgba(139, 92, 246, 0.15);\n}\n\nhtml[data-theme=\"light\"] .btn-delete-small {\n  background: linear-gradient(135deg, rgba(185, 28, 28, 0.08) 0%, rgba(220, 38, 38, 0.08) 100%) !important;\n  color: #b91c1c !important;\n  border: 1px solid rgba(220, 38, 38, 0.25) !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\nhtml[data-theme=\"light\"] .btn-delete-small:hover {\n  background: linear-gradient(135deg, #b91c1c 0%, #ef4444 100%) !important;\n  color: #ffffff !important;\n  border-color: #b91c1c !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(185, 28, 28, 0.35), 0 0 10px rgba(220, 38, 38, 0.15);\n}\n\n/* Dark mode overrides for small buttons in Sections.css */\nhtml[data-theme=\"dark\"] .btn-test {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(139, 92, 246, 0.06) 100%) !important;\n  color: #a5b4fc !important;\n  border: 1px solid rgba(99, 102, 241, 0.35) !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-edit-small {\n  background: linear-gradient(135deg, rgba(168, 85, 247, 0.08) 0%, rgba(139, 92, 246, 0.06) 100%) !important;\n  color: #c084fc !important;\n  border: 1px solid rgba(168, 85, 247, 0.35) !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-delete-small {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.06) 0%, rgba(220, 38, 38, 0.05) 100%) !important;\n  color: #f87171 !important;\n  border: 1px solid rgba(239, 68, 68, 0.35) !important;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n/* --- Premium Accents, Depth & Contrast Refinements (Sections.css overrides for ConnectionsSection) --- */\n\n/* Card general styles for connection-card to matches dms-conn-card */\nhtml[data-theme=\"light\"] .connection-card {\n  background: rgba(255, 255, 255, 0.75) !important;\n  backdrop-filter: blur(24px) saturate(180%) !important;\n  border: 1.5px solid transparent !important;\n  background-clip: padding-box !important;\n  border-radius: 24px !important;\n  position: relative !important;\n  z-index: 1 !important;\n  box-shadow:\n    0 12px 30px rgba(0, 0, 0, 0.04),\n    0 4px 10px rgba(0, 0, 0, 0.02),\n    inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\nhtml[data-theme=\"dark\"] .connection-card {\n  background: rgba(10, 15, 30, 0.85) !important;\n  backdrop-filter: blur(24px) saturate(180%) !important;\n  border: 1.5px solid transparent !important;\n  background-clip: padding-box !important;\n  border-radius: 24px !important;\n  position: relative !important;\n  z-index: 1 !important;\n  box-shadow:\n    0 20px 40px rgba(0, 0, 0, 0.18),\n    0 8px 18px rgba(0, 0, 0, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.connection-card:hover {\n  transform: translateY(-4px) !important;\n}\n\nhtml[data-theme=\"light\"] .connection-card:hover {\n  box-shadow:\n    0 20px 40px rgba(0, 0, 0, 0.08),\n    0 8px 16px rgba(0, 0, 0, 0.04),\n    inset 0 1px 0 rgba(255, 255, 255, 0.7) !important;\n}\n\nhtml[data-theme=\"dark\"] .connection-card:hover {\n  box-shadow:\n    0 30px 60px rgba(0, 0, 0, 0.25),\n    0 12px 24px rgba(0, 0, 0, 0.12),\n    inset 0 1px 0 rgba(255, 255, 255, 0.12) !important;\n}\n\n/* Card Gradient Border Pseudo Elements (For default non-tested state) */\n.connection-card::before {\n  content: '' !important;\n  position: absolute !important;\n  top: -2.5px !important;\n  bottom: -2.5px !important;\n  left: -2.5px !important;\n  right: -2.5px !important;\n  border-radius: 24px !important;\n  z-index: -1 !important;\n  pointer-events: none !important;\n  padding: 2.5px !important;\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0) !important;\n  -webkit-mask-composite: xor !important;\n  mask-composite: exclude !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  opacity: 0.7 !important;\n  background: transparent !important;\n}\n\n/* Disable card background glows to avoid flooding colors inside */\n.connection-card::after {\n  content: none !important;\n  display: none !important;\n}\n\n/* Default border gradients for cloud providers */\n.connection-card:has(img[alt=\"GCP\"])::before {\n  background: linear-gradient(135deg, #06b6d4, #10b981) !important;\n}\n\n.connection-card:has(img[alt=\"AWS\"])::before {\n  background: linear-gradient(135deg, #ef4444, #ec4899) !important;\n}\n\n.connection-card:has(img[alt=\"Azure\"])::before {\n  background: linear-gradient(135deg, #8b5cf6, #6366f1) !important;\n}\n\n/* Hover border illumination */\n.connection-card:hover::before {\n  opacity: 1.0 !important;\n}\n\n/* Provider Circular Logo containers / Connection Icons */\n.connection-icon {\n  border-radius: 50% !important;\n  width: 48px !important;\n  height: 48px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  transition: all 0.3s ease !important;\n}\n\nhtml[data-theme=\"dark\"] .connection-icon {\n  background: #0d1119 !important;\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3) !important;\n}\n\nhtml[data-theme=\"light\"] .connection-icon {\n  background: #ffffff !important;\n  border: 1px solid rgba(0, 0, 0, 0.08) !important;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05) !important;\n}\n\n/* Tested State Card Surfaces and Borders */\nhtml[data-theme=\"light\"] .connection-card.test-success {\n  background: rgba(240, 253, 250, 0.85) !important;\n  border: 2.5px solid rgba(16, 185, 129, 0.8) !important;\n  box-shadow: 0 10px 25px rgba(16, 185, 129, 0.05) !important;\n}\n\nhtml[data-theme=\"light\"] .connection-card.test-failed {\n  background: rgba(254, 242, 242, 0.85) !important;\n  border: 2.5px solid rgba(239, 68, 68, 0.8) !important;\n  box-shadow: 0 10px 25px rgba(239, 68, 68, 0.05) !important;\n}\n\nhtml[data-theme=\"dark\"] .connection-card.test-success {\n  background: rgba(10, 15, 30, 0.9) !important;\n  border: 2.5px solid #10b981 !important;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(16, 185, 129, 0.15) !important;\n}\n\nhtml[data-theme=\"dark\"] .connection-card.test-failed {\n  background: rgba(10, 15, 30, 0.9) !important;\n  border: 2.5px solid #ef4444 !important;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(239, 68, 68, 0.12) !important;\n}\n\n/* Dark Mode Card Subtle Ambient Glow Backgrounds on Tested state or provider glows */\nhtml[data-theme=\"dark\"] .connection-card:has(img[alt=\"GCP\"])::before {\n  background: radial-gradient(circle, rgba(6, 182, 212, 0.08) 0%, rgba(59, 130, 246, 0.02) 55%, transparent 75%) !important;\n}\n\nhtml[data-theme=\"dark\"] .connection-card:has(img[alt=\"AWS\"])::before {\n  background: radial-gradient(circle, rgba(236, 72, 153, 0.08) 0%, rgba(168, 85, 247, 0.02) 55%, transparent 75%) !important;\n}\n\n/* Glassy Inner Slates / Connection Details container */\n.connection-details {\n  padding: 1rem !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 0.75rem !important;\n  margin-top: 1rem !important;\n}\n\nhtml[data-theme='dark'] .connection-details {\n  background: #090c15 !important;\n  border: 1px solid rgba(255, 255, 255, 0.06) !important;\n  border-radius: 16px !important;\n  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.35) !important;\n}\n\nhtml[data-theme='dark'] .detail-row {\n  background: rgba(255, 255, 255, 0.03) !important;\n  border: 1px solid rgba(255, 255, 255, 0.05) !important;\n  border-radius: 12px !important;\n  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.02) !important;\n  padding: 0.65rem 0.75rem !important;\n  margin: 0 !important;\n}\n\nhtml[data-theme='dark'] .detail-row:hover {\n  background: rgba(255, 255, 255, 0.06) !important;\n  border-color: rgba(255, 255, 255, 0.08) !important;\n}\n\n/* Light Mode: Inner slates / details container tinted by test state */\nhtml[data-theme='light'] .connection-details {\n  background: rgba(0, 0, 0, 0.02) !important;\n  border: 1px solid rgba(0, 0, 0, 0.04) !important;\n  border-radius: 16px !important;\n  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.02) !important;\n}\n\nhtml[data-theme='light'] .connection-card.test-success .connection-details {\n  background: rgba(209, 250, 229, 0.5) !important;\n  border: 1px solid rgba(16, 185, 129, 0.15) !important;\n}\n\nhtml[data-theme='light'] .connection-card.test-failed .connection-details {\n  background: rgba(254, 226, 226, 0.6) !important;\n  border: 1px solid rgba(239, 68, 68, 0.15) !important;\n}\n\nhtml[data-theme='light'] .detail-row {\n  background: #ffffff !important;\n  border: 1px solid rgba(0, 0, 0, 0.06) !important;\n  border-radius: 12px !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;\n  padding: 0.65rem 0.75rem !important;\n  margin: 0 !important;\n}\n\nhtml[data-theme='light'] .detail-row:hover {\n  background: #ffffff !important;\n  border-color: rgba(99, 102, 241, 0.25) !important;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.04) !important;\n}\n\n/* Glass Buttons Base */\n.btn-test,\n.btn-edit-small,\n.btn-delete-small {\n  background: rgba(255, 255, 255, 0.02) !important;\n  backdrop-filter: blur(8px) !important;\n  border-radius: 10px !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  font-weight: 700 !important;\n  font-size: 0.68rem !important;\n  letter-spacing: 0.08em !important;\n  text-transform: uppercase !important;\n  box-shadow: none !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* Light Mode Buttons */\nhtml[data-theme=\"light\"] .btn-test {\n  background: rgba(99, 102, 241, 0.04) !important;\n  border: 1px solid rgba(99, 102, 241, 0.35) !important;\n  color: #4f46e5 !important;\n}\n\nhtml[data-theme=\"light\"] .btn-test:hover {\n  background: rgba(99, 102, 241, 0.1) !important;\n  border-color: #4f46e5 !important;\n  color: #4f46e5 !important;\n  transform: translateY(-2px) !important;\n}\n\nhtml[data-theme=\"light\"] .btn-edit-small {\n  background: rgba(139, 92, 246, 0.04) !important;\n  border: 1px solid rgba(139, 92, 246, 0.35) !important;\n  color: #7c3aed !important;\n}\n\nhtml[data-theme=\"light\"] .btn-edit-small:hover {\n  background: rgba(139, 92, 246, 0.1) !important;\n  border-color: #7c3aed !important;\n  color: #7c3aed !important;\n  transform: translateY(-2px) !important;\n}\n\nhtml[data-theme=\"light\"] .btn-delete-small {\n  background: rgba(239, 68, 68, 0.03) !important;\n  border: 1px solid rgba(239, 68, 68, 0.35) !important;\n  color: #dc2626 !important;\n}\n\nhtml[data-theme=\"light\"] .btn-delete-small:hover {\n  background: rgba(239, 68, 68, 0.08) !important;\n  border-color: #dc2626 !important;\n  color: #dc2626 !important;\n  transform: translateY(-2px) !important;\n}\n\n/* Dark Mode Buttons (Match white text/purple border layout from photo) */\nhtml[data-theme=\"dark\"] .btn-test {\n  background: rgba(99, 102, 241, 0.04) !important;\n  border: 1px solid rgba(99, 102, 241, 0.45) !important;\n  color: #ffffff !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-test:hover {\n  background: rgba(99, 102, 241, 0.15) !important;\n  border-color: #818cf8 !important;\n  color: #ffffff !important;\n  transform: translateY(-2px) !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-edit-small {\n  background: rgba(139, 92, 246, 0.04) !important;\n  border: 1px solid rgba(139, 92, 246, 0.45) !important;\n  color: #ffffff !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-edit-small:hover {\n  background: rgba(139, 92, 246, 0.15) !important;\n  border-color: #a78bfa !important;\n  color: #ffffff !important;\n  transform: translateY(-2px) !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-delete-small {\n  background: rgba(239, 68, 68, 0.04) !important;\n  border: 1px solid rgba(239, 68, 68, 0.45) !important;\n  color: #fca5a5 !important;\n}\n\nhtml[data-theme=\"dark\"] .btn-delete-small:hover {\n  background: rgba(239, 68, 68, 0.15) !important;\n  border-color: #fda4af !important;\n  color: #fca5a5 !important;\n  transform: translateY(-2px) !important;\n}\n\n/* Typography readability and contrast overrides for connection cards */\nhtml[data-theme=\"light\"] .connection-info h3 {\n  color: #090d16 !important;\n  font-weight: 700 !important;\n}\n\nhtml[data-theme=\"light\"] .connection-type {\n  color: #52526b !important;\n  font-weight: 600 !important;\n}\n\nhtml[data-theme=\"light\"] .detail-label {\n  color: #6b7280 !important;\n  font-weight: 600 !important;\n}\n\nhtml[data-theme=\"light\"] .detail-value {\n  color: #0f172a !important;\n  font-weight: 700 !important;\n}\n\nhtml[data-theme=\"dark\"] .connection-info h3 {\n  color: #ffffff !important;\n  font-weight: 700 !important;\n}\n\nhtml[data-theme=\"dark\"] .connection-type {\n  color: #cbd5e1 !important;\n  font-weight: 500 !important;\n}\n\nhtml[data-theme=\"dark\"] .detail-label {\n  color: #94a3b8 !important;\n  font-weight: 600 !important;\n}\n\nhtml[data-theme=\"dark\"] .detail-value {\n  color: #ffffff !important;\n  font-weight: 700 !important;\n}\n\n/* --- Draft Connection Card and Status Badge Styling --- */\nhtml[data-theme=\"light\"] .connection-card.draft {\n  background: rgba(254, 243, 199, 0.75) !important;\n  border: 2.5px solid rgba(245, 158, 11, 0.8) !important;\n  box-shadow: 0 10px 25px rgba(245, 158, 11, 0.05) !important;\n}\n\nhtml[data-theme=\"dark\"] .connection-card.draft {\n  background: rgba(10, 15, 30, 0.9) !important;\n  border: 2.5px solid #fbbf24 !important;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18), 0 0 15px rgba(245, 158, 11, 0.15) !important;\n}\n\nhtml[data-theme=\"light\"] .status-badge-pill.draft {\n  border: 1.5px solid rgba(245, 158, 11, 0.6) !important;\n  color: #d97706 !important;\n  background: transparent !important;\n}\n\nhtml[data-theme=\"dark\"] .status-badge-pill.draft {\n  border: 1px solid rgba(251, 191, 36, 0.6) !important;\n  color: #fbbf24 !important;\n  background: transparent !important;\n}\n\nhtml[data-theme='light'] .connection-card.draft .connection-details {\n  background: rgba(254, 243, 199, 0.4) !important;\n  border: 1px solid rgba(245, 158, 11, 0.15) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
